// French translations
export const fr: Record<string, string> = {
  // Main Menu
  'menu.dashboard': 'Tableau de Bord',
  'menu.orderNew': 'Enregistrement de Produit',
  'menu.deliveryList': 'Liste de Livraison',
  'menu.delivery': 'Livraison',
  'menu.receipt': 'Imprimer Reçu/Étiquette',
  'menu.carWash': 'Lavage auto',
  'menu.referral': 'Inviter',
  'menu.barber': 'Barbier / Coiffeur',
  
  // Definitions
  'menu.definitions': 'Définitions',
  'menu.customers': 'Clients',
  'menu.products': 'Définitions de Produits',
  'menu.pricing': 'Définitions de Prix',
  'menu.tailoring': 'Opérations de Couture',
  'menu.attributes': 'Attributs de Produits',
  'menu.users': 'Utilisateurs',
  'menu.productOrdering': 'Ordre des Produits',
  'menu.discounts': 'Définitions de Réductions',
  
  // Settings
  'menu.settings': 'Paramètres',
  'menu.generalSettings': 'Paramètres Généraux',
  'menu.permissions': 'Gestion des Autorisations',
  'menu.subscription': 'Abonnement',
  'menu.invoices': 'Gestion des Factures',
  'menu.expenses': 'Saisie des Dépenses',
  'menu.zReport': 'Z Report',
  'menu.reportsAndAccounting': 'Rapports & Comptabilité',
  'menu.systemAndCommunication': 'Système & Communication',
  'menu.reportsList': 'Liste des Reçus',
  'menu.accountStatement': 'Relevé de Compte',
  'reportsList.totalReceipts': 'Total des reçus',
  'reportsList.registered': 'Enregistré',
  'reportsList.delivered': 'Livré',
  'reportsList.totalRevenueExclCancelled': 'Chiffre d\'affaires total (sans annulations)',
  'reportsList.activeOnly': 'Commandes actives uniquement',
  'reportsList.receiptNumber': 'N° de reçu',
  'reportsList.customer': 'Client',
  'reportsList.phone': 'Téléphone',
  'reportsList.date': 'Date',
  'reportsList.amount': 'Montant',
  'reportsList.status': 'Statut',
  'reportsList.payment': 'Paiement',
  'reportsList.searchPlaceholder': 'N° de reçu, nom du client ou tél...',
  'reportsList.noOrders': 'Aucune commande trouvée',
  'reportsList.cancelled': 'Annulé',
  'reportsList.reprint': 'Réimprimer',
  'menu.tickets': 'Demandes de Support',
  'menu.support': 'Support',
  'menu.profile': 'Profil',
  'menu.logout': 'Déconnexion',
  'menu.notifications': 'Notifications SMS/WhatsApp',
  'menu.whatsappConnection': 'Connexion WhatsApp',
  'menu.smsConnection': 'Connexion SMS',
  
  // Dashboard
  'dashboard.title': 'Tableau de Bord',
  'dashboard.todaySales': "Ventes d'Aujourd'hui",
  'dashboard.totalOrders': 'Total des Commandes',
  'dashboard.pendingDeliveries': 'Livraisons en Cours',
  'dashboard.activeCustomers': 'Clients Actifs',
  'dashboard.recentOrders': 'Commandes Récentes',
  'dashboard.viewAll': 'Voir Tout',
  'dashboard.quickActions': 'Actions Rapides',
  'dashboard.newOrder': 'Nouvelle Commande',
  'dashboard.newCustomer': 'Nouveau Client',
  'dashboard.deliveries': 'Livraisons',
  'dashboard.reports': 'Rapports',
  'dashboard.today': "Aujourd'hui",
  'dashboard.yesterday': 'Hier',
  'dashboard.week': 'Semaine',
  'dashboard.month': 'Mois',
  'dashboard.quarter': 'Trimestre',
  'dashboard.year': 'Année',
  'dashboard.totalRevenue': 'Revenu Total',
  'dashboard.totalOrdersCard': 'Total Commandes',
  'dashboard.totalPieces': 'Total Pièces',
  'dashboard.cancelled': 'Annulé',
  'dashboard.inProcess': 'En Cours',
  'dashboard.inProcessDesc': 'Commandes en cours',
  'dashboard.ready': 'Prêt',
  'dashboard.readyDesc': 'Commandes prêtes à livrer',
  'dashboard.delivered': 'Livré',
  'dashboard.deliveredDesc': 'Commandes terminées',
  'dashboard.announcements': 'Annonces',
  'dashboard.announcementAll': 'Général',
  'dashboard.announcementPrivate': 'Privé',
  
  // Order Entry
  'order.title': 'Nouvelle Commande',
  'order.customer': 'Client',
  'order.selectCustomer': 'Sélectionner Client',
  'order.newCustomer': 'Nouveau Client',
  'order.products': 'Produits',
  'order.addProduct': 'Ajouter Produit',
  'order.selectProduct': 'Sélectionner Produit',
  'order.quantity': 'Quantité',
  'order.price': 'Prix',
  'order.total': 'Total',
  'order.discount': 'Réduction',
  'order.subtotal': 'Sous-total',
  'order.tax': 'TVA',
  'order.grandTotal': 'Total Général',
  'order.payment': 'Paiement',
  'order.paymentMethod': 'Méthode de Paiement',
  'order.cash': 'Espèces',
  'order.card': 'Carte de Crédit',
  'order.credit': 'À Crédit',
  'order.amountPaid': 'Montant Payé',
  'order.remainingBalance': 'Solde Restant',
  'order.deliveryDate': 'Date de Livraison',
  'order.notes': 'Notes',
  'order.createOrder': 'Créer Commande',
  'order.cancel': 'Annuler',
  
  // Users
  'users.title': 'Utilisateurs',
  'users.addNew': 'Nouvel Utilisateur',
  'users.name': 'Nom Prénom',
  'users.email': 'E-mail',
  'users.role': 'Rôle',
  'users.pin': 'PIN',
  'users.permissions': 'Autorisations',
  'users.allPermissions': 'Toutes les Autorisations',
  'users.permissionCount': '{count} autorisations',
  'users.changePin': 'Changer PIN',
  'users.edit': 'Modifier',
  'users.delete': 'Supprimer',
  'users.newUser': 'Nouvel Utilisateur',
  'users.editUser': 'Modifier Utilisateur',
  'users.editingUser': 'Modification de {name}',
  'users.deleteUserTitle': 'Supprimer Utilisateur',
  'users.deletingUser': 'Voulez-vous vraiment supprimer {name}?',
  'users.pinCode': 'Code PIN (4-6 chiffres)',
  'users.selectRole': 'Sélectionner rôle',
  'users.patron': 'Patron',
  'users.kasiyer': 'Caissier',
  'users.sofor': 'Chauffeur',
  'users.eleman': 'Employé',
  'users.changePinTitle': 'Changer Code PIN',
  'users.newPin': 'Nouveau Code PIN',
  'users.confirmPin': 'Confirmer Code PIN',
  'users.pinMismatch': 'Les codes PIN ne correspondent pas',
  'users.pinRequired': 'Code PIN requis',
  'users.pinLength': 'Le code PIN doit contenir 4-6 chiffres',
  'users.changingPinFor': 'Changement du PIN pour {name}',
  
  // Products
  'products.title': 'Définitions de Produits',
  'products.addNew': 'Nouveau Produit',
  'products.category': 'Catégorie',
  'products.name': 'Nom du Produit',
  'products.price': 'Prix',
  'products.color': 'Couleur',
  'products.active': 'Actif',
  'products.actions': 'Actions',
  'products.search': 'Rechercher Produit...',
  'products.noProducts': 'Aucun produit trouvé',
  'products.noCategoryProducts': 'Aucun produit dans cette catégorie',
  'products.emptyCart': 'Panier vide',
  
  // Service Types
  'service.tailor': 'Couture',
  'service.dryCleaning': 'Nettoyage à Sec',
  'service.washing': 'Lavage',
  'service.ironing': 'Repassage',
  'service.dyeing': 'Teinture',
  'service.shoeShine': 'Cirage',
  'service.carpet': 'Tapis',
  'service.tailoring': 'Retouches',
  'service.carpetWashing': 'Lavage de Tapis',
  'service.sofaWashing': 'Nettoyage de Canapés',
  'service.carWash': 'Lavage Auto & Detailing',
  'service.barber': 'Barbier / Coiffeur',
  'service.selectService': 'Sélectionner service',
  'service.addToCart': 'Ajouter au Panier',
  'service.total': 'Total',
  
  // Order Create Page
  'orderCreate.cart': 'Panier',
  'orderCreate.totalPieces': 'Total Pièces',
  'orderCreate.plannedDelivery': 'Livraison Prévue',
  'orderCreate.payment': 'Paiement',
  'orderCreate.save': 'Enregistrer',
  'orderCreate.continue': 'Continuer',
  // Area Calculation Dialog
  'areaCalculation.title': 'Area Calculation',
  'areaCalculation.carpetCount': '🔢 Carpet Count',
  'areaCalculation.carpetCountPlaceholder': 'How many carpets?',
  'areaCalculation.directInput': '📏 Enter m² Directly',
  'areaCalculation.totalSqM': '📏 Total m² (for {count} carpets)',
  'areaCalculation.exampleSqM': 'Ex: 12.5',
  'areaCalculation.or': 'OR',
  'areaCalculation.width': 'Width (m)',
  'areaCalculation.height': 'Height (m)',
  'areaCalculation.exampleNumber': 'Ex: 4',
  'areaCalculation.calculatedArea': 'Calculated Area:',
  'areaCalculation.perCarpet': 'Per carpet',
  'areaCalculation.total': 'Total',
  'areaCalculation.continue': 'Continue',

  'orderCreate.allCategories': 'Tous',
  'orderCreate.selectCustomer': 'Sélectionner Client',
  'orderCreate.selectCustomerPlaceholder': 'Sélectionner client',
  'orderCreate.change': 'Modifier',
  'orderCreate.select': 'Sélectionner',
  'orderCreate.balance': 'Solde',
  'orderCreate.searchCustomer': 'Rechercher par nom, téléphone ou adresse...',
  'orderCreate.newCustomer': 'Nouveau Client',
  'orderCreate.customerName': 'Nom Prénom',
  'orderCreate.customerPhone': 'Téléphone',
  'orderCreate.customerEmail': 'E-mail',
  'orderCreate.customerAddress': 'Adresse',
  'orderCreate.addCustomer': 'Ajouter Client',
  'orderCreate.customer': 'Client',
  'orderCreate.serviceType': 'Type de Service',
  'orderCreate.clickToSelect': 'Cliquer pour sélectionner',
  'orderCreate.deliveryDate': 'Date de Livraison',
  'orderCreate.details': 'Détail',
  'orderCreate.itemDetails': 'Détails',
  'orderCreate.tailoringOperations': 'Opérations de Couture',
  'orderCreate.tailoringTitle': 'Opérations de Couture',
  
  // Pricing Page
  'pricing.title': 'Définitions de Prix',
  'pricing.search': 'Rechercher Produit...',
  'pricing.product': 'Produit',
  'pricing.dryCleaning': 'Nettoyage à Sec',
  'pricing.washing': 'Lavage',
  'pricing.ironing': 'Repassage',
  'pricing.dyeing': 'Teinture',
  'pricing.tailoring': 'Retouches',
  'pricing.shoeShine': 'Cirage',
  'pricing.action': 'Action',
  'pricing.save': 'Enregistrer',
  'pricing.saving': 'Enregistrement...',
  'pricing.pricesSaved': 'Prix enregistrés',
  'pricing.pricesSaveError': 'Impossible d\'enregistrer les prix',
  'pricing.noProducts': 'Aucun produit trouvé',
  'pricing.loadError': 'Impossible de charger les produits',
  
  // Tailoring Page
  'tailoring.title': 'Opérations de Couture',
  'tailoring.addNew': 'Nouvelle Opération',
  
  // Attributes Page
  'attributes.title': 'Attributs de Produits',
  'attributes.colors': 'Couleurs',
  'attributes.stains': 'Types de Taches',
  'attributes.damages': 'Types de Dommages',
  'attributes.add': 'Ajouter',
  
  // Permissions Page
  'permissions.title': 'Gestion des Autorisations',
  'permissions.subtitle': 'Définir les autorisations pour les rôles patron et caissier',
  'permissions.about': 'À propos de la Gestion des Autorisations',
  'permissions.patronInfo': '<strong>Patron:</strong> Rôle administrateur principal avec toutes les autorisations système.',
  'permissions.cashierInfo': '<strong>Caissier:</strong> Rôle utilisateur avec autorisations limitées pour les opérations quotidiennes.',
  'permissions.saveSuccess': 'Autorisations enregistrées',
  'permissions.saveError': 'Impossible d\'enregistrer les autorisations',
  'permissions.patron': 'Patron',
  'permissions.cashier': 'Caissier',
  'permissions.patronRole': 'Administrateur avec toutes autorisations',
  'permissions.cashierRole': 'Utilisateur avec autorisations limitées',
  'permissions.activePermissions': 'Autorisations Actives:',
  'permissions.selectAllPatron': 'Tout Sélectionner Patron',
  'permissions.deselectAllPatron': 'Tout Désélectionner Patron',
  'permissions.selectAllCashier': 'Tout Sélectionner Caissier',
  'permissions.deselectAllCashier': 'Tout Désélectionner Caissier',
  'permissions.saving': 'Enregistrement...',
  'permissions.permissionList': 'Liste des Autorisations',
  'permissions.infoTitle': 'À propos de la Gestion des Autorisations',
  'permissions.infoText1': 'Rôle administrateur principal avec toutes les autorisations système.',
  'permissions.infoText2': 'Rôle utilisateur avec autorisations limitées pour les opérations quotidiennes.',
  'permissions.infoText3': 'Les modifications ne seront pas effectives tant qu\'elles ne sont pas enregistrées.',
  'permissions.infoText4': 'Les autorisations peuvent être personnalisées pour chaque rôle.',
  
  // Driver Dashboard Page
  'driver.title': 'Tableau de Bord Chauffeur',
  'driver.todayRevenue': 'Revenu du Jour',
  'driver.totalPieces': 'Total Pièces',
  'driver.pending': 'En Cours',
  'driver.ready': 'Prêt',
  'driver.pickup': 'Collecte Produit',
  
  // Subscription Page
  'subscription.title': 'Plans d\'Abonnement',
  'subscription.currentPlan': 'Votre Plan Actuel',
  'subscription.upgradePlan': 'Mettre à niveau',
  'subscription.downgradePlan': 'Rétrograder',
  'subscription.choosePlan': 'Choisir un Plan',
  'subscription.billingCycle': 'Cycle de Facturation',
  'subscription.monthly': 'Mensuel',
  'subscription.yearly': 'Annuel',
  'subscription.perMonth': '/mois',
  'subscription.perYear': '/an',
  'subscription.plusVAT': '+ TVA',
  'subscription.save': 'Économisez {percent}%',
  'subscription.mostPopular': 'Le Plus Populaire',
  'subscription.freeTrial': '{months} mois gratuit',
  'subscription.featuresIncluded': 'Fonctionnalités incluses:',
  'subscription.starter': 'Starter',
  'subscription.starterDesc': 'Parfait pour les petites entreprises',
  'subscription.professional': 'Professional',
  'subscription.professionalDesc': 'Pour les entreprises en croissance',
  'subscription.enterprise': 'Enterprise',
  'subscription.enterpriseDesc': 'Solutions d\'entreprise',
  'subscription.maxReceipts': 'Maximum {count} reçus/mois',
  'subscription.maxUsers': '{count} comptes utilisateur',
  'subscription.whatsappCredits': '🎁 {count} crédits WhatsApp offerts',
  'subscription.basicReports': 'Rapports de base',
  'subscription.advancedReports': 'Rapports avancés',
  'subscription.customReports': 'Rapports personnalisés',
  'subscription.whatsappIntegration': 'Intégration WhatsApp',
  'subscription.supportTicket': 'Temps de réponse ticket: {hours} heures',
  'subscription.supportTicketBusiness': 'Temps de réponse ticket: {hours} heures (heures ouvrables)',
  'subscription.accountManagement': 'Gestion de compte',
  'subscription.driverApp': 'Application mobile chauffeur',
  'subscription.prioritySupport': 'Support prioritaire',
  'subscription.managerApp': 'Application mobile - vue gestionnaire',
  'subscription.paymentTitle': 'Finaliser le Paiement',
  'subscription.planSelection': 'Plan Sélectionné',
  'subscription.billingPeriod': 'Période de Facturation',
  'subscription.month': 'mois',
  'subscription.year': 'année',
  'subscription.subtotal': 'Sous-total',
  'subscription.tax': 'TVA ({rate}%)',
  'subscription.total': 'Total',
  'subscription.couponCode': 'Code Promo',
  'subscription.applyCoupon': 'Appliquer',
  'subscription.removeCoupon': 'Retirer',
  'subscription.discount': 'Remise',
  'subscription.invalidCoupon': 'Code promo invalide',
  'subscription.couponVerificationFailed': 'Vérification du coupon échouée',
  'subscription.couponRemoved': 'Coupon retiré',
  'subscription.billingInfo': 'Informations de Facturation',
  'subscription.companyName': 'Nom de l\'Entreprise',
  'subscription.companyNamePlaceholder': 'Entrez le nom de l\'entreprise',
  'subscription.taxNumber': 'Numéro de TVA',
  'subscription.taxNumberPlaceholder': 'Entrez le numéro de TVA',
  'subscription.phone': 'Téléphone',
  'subscription.phonePlaceholder': 'Entrez le numéro de téléphone',
  'subscription.address': 'Adresse',
  'subscription.addressPlaceholder': 'Entrez l\'adresse de facturation',
  'subscription.corporateInvoice': 'Facture d\'Entreprise',
  'subscription.individualInvoice': 'Facture Individuelle',
  'subscription.paymentMethod': 'Méthode de Paiement',
  'subscription.creditCard': 'Carte de Crédit',
  'subscription.bankTransfer': 'Virement Bancaire',
  'subscription.cardNumber': 'Numéro de Carte',
  'subscription.cardNumberPlaceholder': 'Entrez le numéro de carte',
  'subscription.expiryDate': 'Date d\'Expiration',
  'subscription.cvc': 'CVC',
  'subscription.completePayment': 'Finaliser le Paiement',
  'subscription.processing': 'Traitement...',
  'subscription.redirectingToPayment': 'Redirection vers la page de paiement...',
  'subscription.paymentSuccess': '✅ Paiement réussi! Votre abonnement a été activé.',
  'subscription.paymentCompleted': '🎉 Paiement finalisé avec succès!',
  'subscription.paymentCancelled': '❌ Paiement annulé.',
  'subscription.paddleTestCards': 'Cartes de test Paddle imprimées dans la console! (F12)',
  'subscription.sandboxTestCards': '🎴 CARTES DE TEST (SANDBOX)',
  'subscription.successfulPaymentCards': '✅ CARTES DE TEST RÉUSSIES:',
  'subscription.failedPaymentCards': '❌ CARTES DE TEST ÉCHOUÉES:',
  'subscription.invalidCard': '📌 Carte invalide:',
  'subscription.sandboxOnly': '📝 NOTE: Ces cartes ne fonctionnent que dans l\'environnement Sandbox!',
  'subscription.enterCompanyName': 'Entrez le nom de l\'entreprise',
  'subscription.enterPhone': 'Entrez le numéro de téléphone',
  'subscription.enterTaxNumber': 'Entrez le numéro de TVA',
  'subscription.selectPackage': 'Veuillez sélectionner un forfait',
  'subscription.selectPlan': 'Veuillez sélectionner un plan',
  'subscription.paddleNotLoaded': 'SDK Paddle pas encore chargé. Veuillez recharger la page.',
  'subscription.paymentError': 'Erreur de paiement: ',
  'subscription.paymentCreationFailed': 'Impossible de créer le paiement. Veuillez vérifier les journaux de la console.',
  'subscription.paddleConfigurationMissing': '⚠️ Configuration Paddle Manquante!',
  'subscription.paddleDashboardRequired': '⚠️ Configuration du Tableau de Bord Paddle Requise!',
  'subscription.paddleApiNotConfigured': 'Clé API Paddle non configurée. Veuillez contacter votre administrateur.',
  'subscription.cancelConfirm': 'Êtes-vous sûr de vouloir annuler votre abonnement? Votre service continuera jusqu\'à la fin de la période de facturation.',
  'subscription.cancelSuccess': '✅ Abonnement annulé. Votre service continuera jusqu\'à la fin de la période de facturation.',
  'subscription.cancelFailed': 'Annulation échouée',
  'subscription.region.turkey': '🇹🇷 Turquie',
  'subscription.region.europe': '🇪🇺 Europe',
  'subscription.region.other': '🌎 Autre',
  'subscription.status': 'Statut',
  'subscription.active': 'Actif',
  'subscription.sandboxMode': '🧪 SANDBOX (Mode Test)',
  'subscription.liveMode': '🚀 LIVE (Production)',
  'subscription.paddleActive': 'Actif',
  'subscription.paddleConfigured': '✅ Oui',
  'subscription.paddleNotConfigured': '❌ Non',
  'subscription.whatsappCreditsTitle': 'Crédits WhatsApp',
  'subscription.whatsappCreditsPackages': 'Forfaits de Crédits',
  'subscription.whatsappCurrentBalance': 'Solde Actuel',
  'subscription.whatsappCreditsAmount': '{count} Crédits',
  'subscription.whatsappPurchaseCredits': 'Acheter des Crédits',
  
  // Invoices Page
  'invoices.title': 'Gestion des Factures',
  'invoices.subtitle': 'Voir et télécharger vos factures d\'abonnement',
  
  // Common Form Fields
  'form.color': 'Couleur',
  'form.stain': 'Tache',
  'form.damage': 'Dommage',
  'form.notes': 'Notes',
  'form.area': 'Zone',
  
  // Stain Types
  'stain.blood': 'Sang',
  'stain.oil': 'Huile',
  'stain.ink': 'Encre',
  'stain.teaCoffee': 'Thé/Café',
  'stain.fruit': 'Fruit',
  'stain.rust': 'Rouille',
  'stain.paint': 'Peinture',
  'stain.mud': 'Boue',
  'stain.salt': 'Sel',
  'stain.none': 'Aucune',
  'stain.status': 'État de la tache',
  'stain.multiple': 'État de la tache (Sélection multiple)',
  'stain.other': 'Autre type de tache (Appuyez sur Entrée pour ajouter)...',
  
  // Expenses Page
  'expenses.title': 'Saisie des Dépenses',
  'expenses.addNew': 'Nouvelle Dépense',
  'expenses.total': 'Total Dépenses',
  'expenses.totalToday': 'Total Dépenses du Jour',
  'expenses.deletePermission': 'ℹ️ L\'autorisation de supprimer les dépenses appartient uniquement au rôle patron.',
  'expenses.description': 'Description',
  'expenses.amount': 'Montant',
  'expenses.category': 'Catégorie',
  'expenses.noExpenses': 'Aucune dépense enregistrée aujourd\'hui',
  'expenses.newExpense': 'Nouvelle Dépense',
  'expenses.descriptionLabel': 'Description *',
  'expenses.amountLabel': 'Montant *',
  'expenses.categoryLabel': 'Catégorie *',
  'expenses.categoryPlaceholder': 'Sélectionner catégorie...',
  'expenses.deleteTitle': 'Supprimer Dépense',
  'expenses.deleteConfirm': 'Voulez-vous vraiment supprimer cette dépense?',
  'expenses.descriptionField': 'Description:',
  'expenses.categoryField': 'Catégorie:',
  'expenses.amountField': 'Montant:',
  'expenses.dateField': 'Date:',
  'expenses.cancel': 'Annuler',
  'expenses.yesDelete': 'Oui, Supprimer',
  'expenses.deleting': 'Suppression...',
  'expenses.saved': 'Dépense enregistrée',
  'expenses.saveError': 'Impossible d\'enregistrer la dépense',
  'expenses.deleted': 'Dépense supprimée',
  'expenses.deleteError': 'Impossible de supprimer la dépense',
  'expenses.loadError': 'Impossible de charger les dépenses',
  'expenses.dateFilter': 'Filtre de Date',
  'expenses.showDateFilter': 'Sélectionner Plage de Dates',
  'expenses.startDate': 'Date de Début',
  'expenses.endDate': 'Date de Fin',
  'expenses.applyFilter': 'Filtrer',
  'expenses.clearFilter': 'Effacer',
  'expenses.activeFilter': 'Filtre Actif',
  'expenses.filterApplied': 'Filtre de date appliqué',
  'expenses.filterCleared': 'Filtre effacé',
  'expenses.selectBothDates': 'Veuillez sélectionner les dates de début et de fin',
  'expenses.canOnlyDeleteToday': 'Vous ne pouvez supprimer que les dépenses saisies aujourd\'hui.',
  'expenses.myBranch': 'Mon agence',
  'expenses.noBranchSelected': '— Aucune agence sélectionnée —',
  'expenses.branchSelect': 'Sélectionner une agence',
  'expenses.excelError': 'Impossible de créer le fichier Excel',
  'expenses.exportExcel': 'Excel',
  'expenses.records': 'enregistrements',
  'expenses.categoryBy': 'Par catégorie',
  'expenses.allTypes': 'Tous les types',
  'expenses.noBranch': 'Sans agence',
  'expenses.allBranches': 'Toutes les agences',
  'expenses.expenseType': 'Type de dépense',
  
  // Z Report Page
  'zReport.title': 'Rapport Z',
  
  // Account Statement Page
  'accountStatement.title': 'Relevé de Compte',
  'accountStatement.subtitle': 'Suivi des dettes et créances par client',
  'accountStatement.selectCustomer': 'Sélectionner Client',
  'accountStatement.customerPlaceholder': 'Sélectionner client...',
  'accountStatement.searchCustomer': 'Rechercher par nom, téléphone ou adresse...',
  'accountStatement.noCustomerSelected': 'Veuillez sélectionner un client',
  'accountStatement.currentBalance': 'Solde Actuel',
  'accountStatement.totalDebt': 'Dette Totale',
  'accountStatement.totalPayments': 'Total Paiements',
  'accountStatement.transactions': 'Transactions',
  'accountStatement.noTransactions': 'Aucune transaction trouvée pour ce client',
  'accountStatement.date': 'Date',
  'accountStatement.description': 'Description',
  'accountStatement.debit': 'Débit',
  'accountStatement.credit': 'Crédit',
  'accountStatement.balance': 'Solde',
  'accountStatement.order': 'Commande',
  'accountStatement.payment': 'Paiement',
  'accountStatement.loadError': 'Impossible de charger le relevé de compte',
  'accountStatement.addPayment': 'Ajouter Paiement',
  'accountStatement.paymentAmount': 'Montant du Paiement',
  'accountStatement.paymentMethod': 'Méthode de Paiement',
  'accountStatement.paymentNotes': 'Description (Optionnel)',
  'accountStatement.recordPayment': 'Enregistrer Paiement',
  'accountStatement.paymentSaved': 'Paiement enregistré',
  'accountStatement.paymentError': 'Impossible d\'enregistrer le paiement',
  'accountStatement.selectCustomerFirst': 'Veuillez d\'abord sélectionner un client',
  'accountStatement.exportStatement': 'Télécharger Relevé',
  'accountStatement.exportStatementPDF': 'Télécharger PDF',
  'accountStatement.noCustomersFound': 'Aucun client trouvé',
  'accountStatement.searchHint': 'Entrez au moins 2 caractères pour rechercher',
  'accountStatement.selectedCustomer': 'Client Sélectionné',
  'accountStatement.changeCustomer': 'Changer Client',
  
  // Notification Settings Page
  'notifications.title': 'Notifications SMS/WhatsApp',
  'notifications.subtitle': 'Modifier les paramètres de notification SMS et WhatsApp',
  
  // WhatsApp Connection Page
  'whatsapp.title': 'Connexion WhatsApp',
  'whatsapp.subtitle': 'Gérer votre connexion WhatsApp Business API',
  'whatsapp.connectionStatus': 'État de Connexion',
  'whatsapp.disconnected': 'Non Connecté',
  'whatsapp.notConnectedMessage': 'Votre compte WhatsApp n\'est pas encore connecté',
  'whatsapp.connectWithQR': 'Connecter avec QR Code',
  'whatsapp.importantInfo': 'Informations Importantes',
  'whatsapp.info1': '1. Scannez le QR code avec l\'application WhatsApp de votre téléphone',
  'whatsapp.info2': '2. Après connexion, vous pouvez envoyer des messages automatiques',
  'whatsapp.info3': '3. Pour déconnecter, déconnectez-vous des paramètres WhatsApp',
  'whatsapp.info4': '4. Le QR code se renouvelle automatiquement après 60 secondes',
  'whatsapp.generateQR': 'Générer QR Code',
  
  // Profile Page
  'profile.subscriptionBilling': 'Abonnement et Facturation',
  
  // Error Boundary
  'errorBoundary.unknownError': 'Une erreur s\'est produite',
  'errorBoundary.pageNotFound': 'Page Non Trouvée',
  'errorBoundary.pageNotFoundDetails': 'La page que vous recherchez n\'existe pas ou a été déplacée.',
  'errorBoundary.unauthorized': 'Accès Non Autorisé',
  'errorBoundary.unauthorizedDetails': 'Vous n\'êtes pas autorisé à accéder à cette page.',
  'errorBoundary.forbidden': 'Accès Refusé',
  'errorBoundary.forbiddenDetails': 'Vous n\'avez pas les autorisations suffisantes pour effectuer cette action.',
  'errorBoundary.serverError': 'Erreur Serveur',
  'errorBoundary.serverErrorDetails': 'Une erreur s\'est produite côté serveur. Veuillez réessayer plus tard.',
  'errorBoundary.technicalDetails': 'Détails Techniques',
  'errorBoundary.reload': 'Recharger la Page',
  'errorBoundary.goHome': 'Retour à l\'Accueil',
  'errorBoundary.persistentIssue': 'Si le problème persiste, veuillez contacter l\'équipe de support.',
  
  // Delivery
  'delivery.title': 'Gestion de Livraison',
  'delivery.pending': 'En Cours',
  'delivery.ready': 'Prêt',
  'delivery.delivered': 'Livré',
  'delivery.orderNumber': 'N° Commande',
  'delivery.customer': 'Client',
  'delivery.items': 'Produits',
  'delivery.total': 'Total',
  'delivery.deliveryDate': 'Date de Livraison',
  'delivery.status': 'Statut',
  'delivery.actions': 'Actions',
  'delivery.markReady': 'Marquer comme Prêt',
  'delivery.markDelivered': 'Marquer comme Livré',
  'delivery.printReceipt': 'Imprimer Reçu',
  
  // Delivery List Page
  'deliveryList.title': 'Liste de Livraison',
  'deliveryList.search': 'N° reçu, nom client ou téléphone...',
  'deliveryList.all': 'Tous',
  'deliveryList.pending': 'En Cours',
  'deliveryList.ready': 'Prêt',
  'deliveryList.date': 'Date',
  'deliveryList.pieces': 'Pièces',
  'deliveryList.amount': 'Montant',
  'deliveryList.readyButton': 'Prêt',
  'deliveryList.receiptButton': 'Reçu',
  'deliveryList.noOrders': 'Aucune commande trouvée',
  'deliveryList.statusUpdated': 'Commande marquée comme prête',
  'deliveryList.statusUpdateError': 'Impossible de mettre à jour le statut',
  'deliveryList.loadError': 'Impossible de charger les commandes',
  'deliveryList.whatsappSending': '📱 Envoi du message WhatsApp...',
  'deliveryList.smsSent': '📨 Message SMS envoyé',
  
  // Delivery Page
  'deliveryPage.title': 'Livraison',
  'deliveryPage.search': 'Rechercher par n° reçu, nom, téléphone ou adresse...',
  'deliveryPage.pieces': 'Pièces',
  'deliveryPage.amount': 'Montant',
  'deliveryPage.payment': 'Paiement',
  'deliveryPage.deliverButton': 'Livrer',
  'deliveryPage.noOrdersFound': 'Aucune commande prête à livrer',
  'deliveryPage.noReadyOrders': 'Aucune commande prête à livrer',
  'deliveryPage.minSearchLength': 'Entrez au moins 3 caractères pour rechercher',
  'deliveryPage.paymentDialogTitle': 'Paiement à la Livraison',
  'deliveryPage.ordersLoadError': 'Impossible de charger les commandes',
  'deliveryPage.searchError': 'Impossible de rechercher',
  'deliveryPage.deliverySuccess': 'Commande livrée',
  'deliveryPage.deliveryError': 'Échec de la livraison',
  'deliveryPage.whatsappSending': '📱 Envoi du reçu par WhatsApp...',
  'deliveryPage.statusNotReady': 'Commande trouvée mais pas prête à livrer',
  'deliveryPage.statusPending': 'En Cours - Marquez d\'abord comme prêt depuis "Liste de Livraison"',
  'deliveryPage.statusDelivered': 'Livré',
  'deliveryPage.statusCancelled': 'Annulé',
  'deliveryPage.receiptDelivered': '✅ *LIVRÉ*',
  'deliveryPage.showItems': 'Afficher les Produits',
  'deliveryPage.itemsList': 'Détails de la Commande',
  'deliveryPage.unknownProduct': 'Produit Inconnu',
  
  // Receipt Page
  'receipt.title': 'Reçu et Étiquette',
  'receipt.customerReceipt': 'Reçu Client',
  'receipt.back': 'Retour',
  'receipt.print': 'Imprimer Reçu',
  'receipt.whatsappSend': 'Envoyer WhatsApp',
  'receipt.receiptNumber': 'N° Reçu',
  'receipt.date': 'Date',
  'receipt.time': 'Heure',
  'receipt.product': 'Produit',
  'receipt.quantity': 'Quantité',
  'receipt.price': 'Prix',
  'receipt.totalPieces': 'Total Pièces',
  'receipt.subtotal': 'Sous-total',
  'receipt.tax': 'TVA',
  'receipt.total': 'TOTAL',
  'receipt.payment': 'Paiement',
  'receipt.plannedDelivery': 'Livraison Prévue',
  'receipt.notFound': 'Reçu non trouvé',
  'receipt.newOrder': 'Nouvelle Commande',
  'receipt.search': 'Recherche et Réimpression de Reçu',
  'receipt.searchPlaceholder': 'Rechercher par N° Reçu, Nom Client ou Téléphone...',
  'receipt.searchEmpty': 'Entrez un n° de reçu ou nom de client',
  'receipt.noResults': 'Aucun résultat trouvé',
  'receipt.resultsCount': '{count} résultat(s) trouvé(s)',
  'receipt.printButton': 'Imprimer Reçu',
  'receipt.products': 'produits',
  'receipt.loadError': 'Impossible de charger les données',
  'receipt.whatsappOpening': 'Ouverture de WhatsApp...',
  'receipt.labelPrinting': 'Impression de l\'étiquette {current}/{total}...',
  'receipt.andLabel': 'et Étiquette',
  'receipt.stain': 'Tache',
  'receipt.damage': 'Dommage',
  'receipt.taxPercent': 'TVA (%20)',
  'receipt.thankYou': 'Merci!',

  // Payment Methods
  'payment.cash': 'Espèces',
  'payment.adjustment': 'Ajustement de solde',
  'payment.card': 'Carte de Crédit (POS)',
  'payment.creditCard': 'Carte de Crédit',
  'payment.mealCard': 'Carte Restaurant',
  'payment.onDelivery': 'À la Livraison',
  'payment.account': 'Compte',
  
  // Customers Page
  'customers.title': 'Clients',
  'customers.addNew': 'Nouveau Client',
  'customers.search': 'Rechercher Client...',
  'customers.name': 'Nom Prénom',
  'customers.phone': 'Téléphone',
  'customers.email': 'E-mail',
  'customers.address': 'Adresse',
  'customers.totalOrders': 'Nombre de Commandes',
  'customers.totalSpent': 'Total Dépensé',
  'customers.balance': 'Solde',
  'customers.actions': 'Actions',
  'customers.edit': 'Modifier',
  'customers.delete': 'Supprimer',
  'customers.noCustomers': 'Aucun client trouvé',
  'customers.noResults': 'Aucun résultat trouvé',
  'customers.showingFirst50': 'Affichage des 50 premiers résultats',
  'customers.totalResults': 'total',
  'customers.tableCustomer': 'Client',
  'customers.tableContact': 'Contact',
  'customers.tableAddress': 'Adresse',
  'customers.tableNotifications': 'Notifications',
  'customers.tableBalance': 'Solde',
  'customers.tableActions': 'Actions',
  'customers.totalCount': 'Total {count} clients',
  'customers.notes': 'Note',
  'customers.whatsappEnabled': 'WhatsApp',
  'customers.smsEnabled': 'SMS',
  'customers.searchPlaceholder': 'Rechercher par nom, téléphone, email ou adresse...',
  'customers.updated': 'Client mis à jour',
  'customers.updateError': 'Impossible de mettre à jour le client',
  'customers.added': 'Client ajouté',
  'customers.addError': 'Impossible d\'ajouter le client',
  'customers.deleted': 'Client supprimé',
  'customers.deleteError': 'Impossible de supprimer le client',
  'customers.deleteConfirm': 'Voulez-vous vraiment supprimer le client "{name}"?',
  'customers.loadError': 'Impossible de charger les clients',
  
  // Settings Page
  'settings.title': 'Paramètres',
  'settings.general': 'Paramètres Généraux',
  'settings.companyName': 'Nom de l\'Entreprise',
  'settings.language': 'Langue',
  'settings.currency': 'Devise',
  'settings.currencyPosition': 'Position de la Devise',
  'settings.currencyPositionLeft': 'Gauche ($100.00)',
  'settings.currencyPositionRight': 'Droite (100.00₺)',
  'settings.currencyPositionPreview': 'Symbole {position}: {example}',
  'settings.currencyPositionPreviewLeft': 'Symbole à gauche',
  'settings.currencyPositionPreviewRight': 'Symbole à droite',
  'settings.numberFormat': 'Format de Nombre',
  'settings.currencyFormat': 'Format de Devise',
  'settings.showDecimals': 'Afficher les Décimales',
  'settings.showDecimalsDesc': 'Afficher la partie décimale dans les prix',
  'settings.dateFormat': 'Format de Date',
  'settings.timezone': 'Fuseau Horaire',
  'settings.deliveryDays': 'Délai de Livraison (Jours)',
  'settings.workOnSunday': 'Travailler le Dimanche',
  'settings.defaultServiceType': 'Type de Service par Défaut',
  'settings.defaultServiceTypeDesc': 'Type de service automatiquement sélectionné à l\'ouverture de l\'écran d\'enregistrement de produit',
  'settings.defaultCategory': 'Catégorie par Défaut',
  'settings.defaultCategoryDesc': 'Catégorie automatiquement sélectionnée à l\'ouverture de l\'écran d\'enregistrement de produit',
  'settings.companyLogo': 'Logo de l\'Entreprise',
  'settings.logoDescription': 'Le logo apparaîtra sur les reçus et en haut à gauche du programme. Taille recommandée: 200x80px',
  'settings.uploadLogo': 'Télécharger Logo',
  'settings.removeLogo': 'Supprimer Logo',
  'settings.noLogo': 'Pas de logo',
  'settings.whatsappTemplates': 'Modèles de Messages WhatsApp',
  'settings.smsTemplates': 'Modèles de Messages SMS',
  'settings.orderCreated': 'Commande Créée',
  'settings.orderReady': 'Commande Prête',
  'settings.orderDelivered': 'Commande Livrée',
  'settings.receiptSettings': 'Paramètres de Reçu',
  'settings.showTax': 'Afficher TVA',
  'settings.taxRate': 'Taux de TVA (%)',
  'settings.footerText': 'Texte de Pied de Page',
  'settings.receiptFooterText': 'Pied de Page du Reçu',
  'settings.receiptNote': 'Note de Pied de Page du Reçu',
  'settings.socialMedia': 'Réseaux Sociaux & Contact',
  'settings.instagram': 'Instagram',
  'settings.facebook': 'Facebook',
  'settings.website': 'Site Web',
  'settings.phone': 'Téléphone',
  'settings.address': 'Adresse',
  'settings.dangerZone': 'Zone Dangereuse',
  'settings.deleteDemoDataWarning': 'Supprime les clients exemples ajoutés automatiquement à l\'installation, avec leurs reçus et paiements. Les clients et reçus que vous avez ajoutés ne sont pas supprimés.',
  'settings.productsWillBeKept': 'Les définitions de produits seront conservées.',
  'settings.deleteDemoDataTitle': 'Données de Démonstration Seront Supprimées',
  'settings.deleteDemoDataConfirm': 'Cette action est irréversible ! Les clients exemples et leurs reçus/paiements seront supprimés ; vos propres clients et reçus seront conservés.',
  'toast.noDemoData': 'Aucun client exemple à supprimer.',
  'toast.demoCustomersKept': '{n} client(s) exemple conservé(s) car ils ont des reçus que vous avez créés ; seuls leurs reçus exemples ont été supprimés.',
  'settings.areYouSure': 'Voulez-vous vraiment continuer?',
  'settings.deleting': 'Suppression...',
  'settings.yesDelete': 'Oui, Supprimer',
  'settings.deleteDemoData': 'Supprimer Données de Démonstration',
  'settings.deleteDemoDataDesc': 'Cette action supprimera définitivement tous les clients, commandes et paiements de démonstration.',
  'settings.deleteButton': 'Supprimer Données de Démonstration',
  'settings.save': 'Enregistrer',
  'settings.loading': 'Chargement...',
  'settings.languageRegion': 'Langue et région',
  'settings.numberFormatDotComma': 'Point pour décimales (1.234,56)',
  'settings.numberFormatCommaDot': 'Virgule pour décimales (1,234.56)',
  'settings.numberFormatSpaceComma': 'Espace pour décimales (1 234,56)',
  'settings.logo': 'Logo',
  'settings.companyNamePlaceholder': 'Entrez le nom de l\'entreprise',
  'settings.addressPlaceholder': 'Entrez l\'adresse',
  'settings.footerTextPlaceholder': 'Entrez le texte de pied de page',
  'settings.receiptNotePlaceholder': 'Entrez la note du reçu',
  'settings.loadSchema': 'Charger le schéma',
  'settings.loadSchemaTitle': 'Charger le schéma de base de données',
  'settings.loadSchemaConfirm': 'Cela créera le schéma de base de données. Continuer?',
  'settings.connected': 'Connecté',
  'settings.notConnected': 'Non connecté',
  'settings.connect': 'Connecter',
  'settings.disconnect': 'Déconnecter',
  
  // Toasts
  'toast.settingsSaved': 'Paramètres enregistrés',
  'toast.settingsError': 'Impossible d\'enregistrer les paramètres',
  'toast.settingsLoadError': 'Impossible de charger les paramètres',
  'toast.logoUploaded': 'Logo téléchargé. N\'oubliez pas d\'enregistrer!',
  'toast.logoRemoved': 'Logo supprimé. N\'oubliez pas d\'enregistrer!',
  'toast.logoSizeError': 'Le fichier logo doit faire moins de 500KB',
  'toast.logoTypeError': 'Seuls les fichiers image peuvent être téléchargés',
  'toast.demoDataDeleted': 'Données de démonstration supprimées',
  'toast.demoDataDeleteError': 'Impossible de supprimer les données de démonstration',
  'toast.orderCreated': 'Commande créée',
  'toast.orderError': 'Impossible de créer la commande',
  'toast.customerAdded': 'Client ajouté',
  'toast.customerError': 'Impossible d\'ajouter le client',
  'toast.productAdded': 'Produit ajouté',
  'toast.productError': 'Impossible d\'ajouter le produit',
  'toast.qrGenerated': 'QR code généré. Veuillez scanner avec votre application WhatsApp Business.',
  'toast.qrError': 'Impossible de générer le QR code',
  'toast.whatsappConnected': 'WhatsApp Business connecté avec succès!',
  'toast.whatsappDisconnected': 'Connexion WhatsApp Business déconnectée',
  'toast.connectionError': 'Impossible d\'enregistrer la connexion',
  'toast.disconnectError': 'Impossible de déconnecter',
  'toast.connectionStatusError': 'Impossible de charger l\'état de connexion',
  'toast.orderSaved': 'Ordre enregistré',
  'toast.orderSaveError': 'Impossible d\'enregistrer l\'ordre',
  'toast.statsError': 'Impossible de charger les statistiques',
  'toast.userAdded': 'Utilisateur ajouté',
  'toast.userAddError': 'Impossible d\'ajouter l\'utilisateur',
  'toast.userUpdated': 'Utilisateur mis à jour',
  'toast.userUpdateError': 'Impossible de mettre à jour l\'utilisateur',
  'toast.usersLoadError': 'Impossible de charger les utilisateurs',
  'toast.pinChanged': 'Code PIN modifié',
  'toast.pinChangeError': 'Impossible de modifier le code PIN',
  'toast.userDeleted': 'Utilisateur supprimé/désactivé avec succès',
  'toast.userDeleteError': 'Impossible de supprimer l\'utilisateur',
  
  // Subscription Banner
  'subscription.warning': 'Avertissement d\'Abonnement',
  'subscription.expiringDays': 'Votre abonnement expire dans {days} jours. Veuillez renouveler pour continuer sans interruption.',
  'subscription.renew': 'Renouveler l\'Abonnement',
  
  // Common
  'common.yes': 'Oui',
  'common.no': 'Non',
  'common.cancel': 'Annuler',
  'common.confirm': 'Confirmer',
  'common.delete': 'Supprimer',
  'common.edit': 'Modifier',
  'common.save': 'Enregistrer',
  'common.search': 'Rechercher',
  'common.loading': 'Chargement...',
  'common.noData': 'Aucune donnée',
  'common.actions': 'Actions',
  'common.status': 'Statut',
  'common.date': 'Date',
  'common.time': 'Heure',
  'common.total': 'Total',
  'common.filter': 'Filtrer',
  'common.export': 'Exporter',
  'common.print': 'Imprimer',
  'common.close': 'Fermer',
  'common.back': 'Retour',
  'common.next': 'Suivant',
  'common.previous': 'Précédent',
  'common.submit': 'Soumettre',
  'common.reset': 'Réinitialiser',
  'common.create': 'Créer',
  'common.creating': 'Création...',
  'common.later': 'Plus tard',
  'common.clear': 'Effacer',
  'common.copied': 'Copié!',
  'common.copyError': 'Échec de la copie',
  
  // Tickets
  'tickets.title': 'Demandes de Support',
  'tickets.newTicket': 'Nouvelle Demande',
  'tickets.noTickets': 'Aucune demande de support',
  'tickets.noTicketsDesc': 'Si vous rencontrez un problème, vous pouvez créer une nouvelle demande de support',
  'tickets.subject': 'Sujet',
  'tickets.description': 'Description',
  'tickets.yourName': 'Votre Nom',
  'tickets.yourNamePlaceholder': 'Entrez votre nom',
  'tickets.subjectPlaceholder': 'Résumez brièvement votre problème',
  'tickets.descriptionPlaceholder': 'Décrivez votre problème en détail',
  'tickets.created': 'Demande de support créée',
  'tickets.createError': 'Impossible de créer la demande de support',
  'tickets.fillAllFields': 'Remplissez tous les champs',
  'tickets.loadError': 'Impossible de charger les tickets',
  'tickets.messages': 'messages',
  'tickets.status.open': 'Ouvert',
  'tickets.status.investigating': 'En Investigation',
  'tickets.status.waitingCustomer': 'En Attente de Réponse Client',
  'tickets.status.closed': 'Résolu',
  'tickets.conversation': 'Conversation',
  'tickets.admin': 'Équipe de Support',
  'tickets.typeMessage': 'Écrivez votre message...',
  'tickets.sendError': 'Impossible d\'envoyer le message',
  'tickets.closedMessage': 'Cette demande a été marquée comme résolue.',
  'tickets.rateSupport': 'Évaluer le Support',
  'tickets.rateExperience': 'Évaluez Votre Expérience',
  'tickets.rateDescription': 'Comment évaluez-vous le support reçu?',
  'tickets.selectRating': 'Veuillez sélectionner une note',
  'tickets.ratingSubmitted': 'Votre note a été enregistrée, merci!',
  'tickets.ratingError': 'Impossible d\'envoyer la note',
  'tickets.yourRating': 'Votre Note',
  'tickets.rating.veryBad': 'Très Mauvais',
  'tickets.rating.bad': 'Mauvais',
  'tickets.rating.okay': 'Moyen',
  'tickets.rating.good': 'Bon',
  'tickets.rating.excellent': 'Excellent',
  
  // Login
  'login.title': 'Cleandy',
  'login.subtitle': 'Système de Gestion de Nettoyage à Sec',
  'login.tenantId': 'ID Entreprise',
  'login.tenantPlaceholder': 'id-entreprise (ex: acme-clean)',
  'login.tenantIdHelp': 'Entrez votre identifiant unique d\'entreprise',
  'login.continue': 'Continuer →',
  'login.notMember': 'Pas encore membre?',
  'login.startTrial': 'Démarrer l\'Essai Gratuit',
  'login.adminLogin': '🔒 Connexion Administrateur',
  'login.enterPin': 'Entrez votre code PIN',
  'login.changeTenant': 'Changer d\'Entreprise',
  'login.clear': 'Effacer',
  'login.delete': 'Supprimer',
  'login.login': 'Se Connecter',
  'login.loggingIn': 'Connexion...',
  'login.defaultPinOwner': 'PIN par défaut: <strong>1234</strong> (Patron)',
  'login.defaultPinCashier': 'PIN par défaut: <strong>0000</strong> (Caissier)',
  'login.systemInitializing': 'Initialisation du système...',
  'login.pinMinLength': 'Le PIN doit contenir au moins 4 chiffres',
  'login.invalidTenantId': 'Entrez un ID d\'entreprise valide',
  'login.tenantNotFound': 'Ce code d\'entreprise n\'a pas été trouvé. Veuillez vérifier ou créer un nouveau compte.',
  'login.loginFailed': 'Échec de connexion',
  'login.welcome': 'Bienvenue, {name}',

  // Signup translations
  'signup.title': 'Démarrer l\'Essai Gratuit',
  'signup.subtitle': 'Essai gratuit de 15 jours, aucune carte de crédit requise',
  'signup.backToLogin': 'Retour à la Page de Connexion',
  'signup.companyCode': 'Code d\'Entreprise',
  'signup.companyCodePlaceholder': 'ex: cleanpro',
  'signup.companyCodeHelp': 'Ce code sera utilisé pour se connecter au système',
  'signup.companyCodeMinLength': 'Le code d\'entreprise doit contenir au moins 3 caractères',
  'signup.companyName': 'Nom de l\'Entreprise',
  'signup.companyNamePlaceholder': 'Nom de Votre Entreprise',
  'signup.companyNameRequired': 'Le nom de l\'entreprise est requis',
  'signup.fullName': 'Nom Prénom',
  'signup.fullNamePlaceholder': 'Votre Nom Prénom',
  'signup.fullNameRequired': 'Le nom prénom est requis',
  'signup.phone': 'Téléphone',
  'signup.phonePlaceholder': '+33 6 12 34 56 78',
  'signup.validPhoneRequired': 'Entrez un numéro de téléphone valide',
  'signup.email': 'E-mail',
  'signup.emailPlaceholder': 'exemple@entreprise.com',
  'signup.validEmailRequired': 'Entrez une adresse e-mail valide',
  'signup.createAccount': 'Créer un Compte',
  'signup.creating': 'Création...',
  'signup.terms': 'En créant un compte, vous acceptez les Conditions d\'Utilisation et la Politique de Confidentialité.',
  'signup.success': 'Inscription réussie! Vos informations de connexion ont été envoyées à votre adresse e-mail.',
  'signup.successTitle': 'Inscription Réussie!',
  'signup.successMessage': 'Votre compte a été créé avec succès.',
  'signup.emailSent': 'Vos informations de connexion ont été envoyées à votre adresse e-mail.',
  'signup.redirecting': 'Redirection vers la page de connexion...',
  'signup.startupPackageLoaded': 'Package de Démarrage Chargé!',
  'signup.products': 'Produits',
  'signup.customers': 'Clients',
  'signup.users': 'Utilisateurs',
  'signup.demoDataReady': '✨ Vos données de démonstration sont prêtes, vous pouvez commencer à les utiliser immédiatement!',
  'signup.loginInfo': '📧 Vos Informations de Connexion',
  'signup.loginInfoSent': '💡 Ces informations ont également été envoyées à votre adresse e-mail',
  'signup.loginNow': 'Se Connecter Maintenant →',
  'signup.hints.companyCode': 'Utilisé pour la connexion',
  'signup.hints.country': 'Votre pays a été détecté automatiquement. Vous pouvez sélectionner un autre pays.',
  'signup.freeTrial': '🎉 Essayez gratuitement pendant 15 jours - Aucune carte de crédit requise!',
  'signup.businessType.question': 'Quel type d\'activité exercez-vous ?',
  'signup.businessType.hint': 'Votre écran par défaut sera défini automatiquement selon votre choix',
  'signup.businessType.continue': 'Continuer',
  'signup.bt.dryCleaning.desc': 'Nettoyage de vêtements, rideaux et textiles',
  'signup.bt.carpetWashing.desc': 'Lavage de tapis, kilims et chemins de couloir',
  'signup.bt.shoeShine.desc': 'Nettoyage et entretien des chaussures',
  'signup.bt.sofaWashing.desc': 'Nettoyage de canapés, sofas et fauteuils',
  'signup.bt.carWash.desc': 'Lavage, polissage et entretien de véhicules',
  'signup.bt.tailoring.desc': 'Couture, retouches et services de confection',
  'signup.bt.barber.desc': 'Coiffeur, barbier et salon de beauté',
  'signup.bt.tailoring.desc': 'Couture, retouches et tailleur',
  'signup.bt.barber.desc': 'Coiffeur, barbier et salon de beauté',
  'signup.companyDetails': 'Informations sur l\'Entreprise',
  'signup.fields.companyCode': 'Code Entreprise',
  'signup.fields.companyName': 'Nom de l\'Entreprise',
  'signup.fields.ownerName': 'Nom du Propriétaire',
  'signup.fields.email': 'E-mail',
  'signup.fields.phone': 'Téléphone',
  'signup.fields.country': 'Pays',
  'signup.fields.username': 'Nom d\'utilisateur',
  'signup.fields.password': 'Mot de passe',
  'signup.fields.confirmPassword': 'Confirmer le mot de passe',
  'signup.placeholders.companyCode': 'ex: entreprise',
  'signup.placeholders.companyName': 'Nom de votre entreprise',
  'signup.placeholders.ownerName': 'Nom complet',
  'signup.placeholders.email': 'exemple@entreprise.com',
  'signup.placeholders.phone': '+33 1 23 45 67 89',

  // Additional missing translations
  'active': 'Actif',
  'add': 'Ajouter',
  'adding': 'Ajout...',
  'address': 'Adresse',
  'amount': 'Montant',
  'back': 'Retour',
  'cancel': 'Annuler',
  'canceling': 'Annulation...',
  'change': 'Modifier',
  'changePin': 'Changer PIN',
  'changing': 'Modification...',
  'changingPin': 'Modification PIN...',
  'clear': 'Effacer',
  'close': 'Fermer',
  'common.exportExcel': 'Telecharger Excel',
  'common.exportToExcel': 'Exporter vers Excel',
  'common.printDate': 'Date impression',
  'common.perPage': 'Par page',
  'common.page': 'Page',
  'common.orders': 'Commandes',
  'common.pieces': 'pièces',
  'completed': 'Termine',
  'confirm': 'Confirmer',
  'create': 'Creer',
  'creating': 'Creation...',
  'damage.none': 'Sans Dommage',
  'damage.other': 'Autre',
  'damage.hole': 'Trou',
  'damage.tear': 'Déchirure',
  'damage.burn': 'Brûlure',
  'damage.fray': 'Effilochage',
  'damage.button': 'Problème de bouton',
  'damage.zipper': 'Fermeture éclair',
  'damage.stain': 'Tache',
  'damage.color': 'Décoloration',
  'delete': 'Supprimer',
  'deleting': 'Suppression...',
  'delivery.loadError': 'Echec chargement livraisons',
  'delivery.noOrders': 'Aucune commande trouvee',
  'delivery.orderDelivered': 'Commande marquee livree',
  'delivery.orderReady': 'Commande marquee prete',
  'delivery.searchOrder': 'Rechercher par numero ou nom...',
  'delivery.updateError': 'Echec mise a jour statut',
  'error': 'Erreur',
  'info': 'Information',
  'login': 'Connexion',
  'login.demoAccount': 'Compte Demo',
  'login.demoCredentials': 'Utilisateur: demo, PIN: 1234',
  'login.demoLoaded': 'Demo utilisateurs, produits, clients crees!',
  'login.firstLoginChangePin': 'Premiere connexion - Changez votre PIN',
  'login.invalidCredentials': 'Identifiants invalides',
  'login.pin': 'PIN',
  'login.pinDescription': '4-6 chiffres',
  'login.pinRequired': 'PIN requis',
  'login.rememberMe': 'Se souvenir',
  'login.signIn': 'Se Connecter',
  'login.signingIn': 'Connexion...',
  'login.tenantIdNotRemembered': 'ID entreprise non memorise',
  'login.tenantRequired': 'ID entreprise requis',
  'login.tryForFree': '30 jours gratuit, sans carte credit',
  'login.username': 'Nom Utilisateur',
  'login.usernameRequired': 'Nom utilisateur requis',
  'login.version': 'Version',
  'logout': 'Deconnexion',
  'notifications': 'Notifications',
  'orderCreate.addressRequired': 'Adresse requise!',
  'orderCreate.credit': 'Credit',
  'orderCreate.debt': 'Dette',
  'orderCreate.discountLabel': 'Reduction (%)',
  'orderCreate.grandTotal': 'Total General',
  'orderCreate.homeDelivery': 'Livraison a Domicile',
  'orderCreate.homeDeliveryAddress': 'Adresse',
  'orderCreate.subtotal': 'Sous-total',
  'settings.addDemoProducts': 'Ajouter des Produits Demo',
  'settings.adding': 'Ajout...',
  'settings.companyInfo': 'Info Entreprise',
  'settings.delete': 'Supprimer',
  'settings.demoProducts': 'Produits Demo',
  'settings.demoProductsDescription': 'Ajoute des produits demo',
  'settings.expenses': 'Depenses',
  'settings.headerInfo': 'Info En-tete',
  'settings.invoices': 'Factures',
  'settings.menu': 'Menu Parametres',
  'settings.phonePlaceholder': 'ex: 0212 123 45 67',
  'settings.receiptPreview': 'Apercu Recu',
  'settings.reports': 'Rapports',
  'settings.tickets': 'Tickets de Support',
  'settings.zReport': 'Rapport Z',
  'zReport.collectedItems': 'Articles Collectes',
  'success': 'Succes',
  'toast.addProduct': 'Ajoutez un produit',
  'toast.addressRequiredForDelivery': 'Adresse requise pour livraison.',
  'toast.cardPaymentError': 'Paiement carte echoue',
  'toast.cardPaymentSuccess': 'Paiement carte reussi!',
  'toast.carpetAddedToCart': 'Tapis ajoute ({area} m2 x {price}/m2)',
  'toast.carpetsAddedToCart': '{count} tapis ajoutes ({area} m2 x {price}/m2)',
  'toast.customerDebt': 'Client a {amount} dette',
  'toast.customerOpenOrders': 'Client a {count} commandes ouvertes',
  'toast.customerSaveError': 'Echec enregistrement client',
  'toast.customerSaved': 'Client enregistre',
  'toast.customerUpdateError': 'Echec mise a jour client',
  'toast.customerUpdated': 'Client mis a jour',
  'toast.deliveryBeforeToday': 'Date livraison ne peut etre avant aujourdhui',
  'toast.enterValidAmount': 'Entrez montant valide',
  'toast.enterValidArea': 'Veuillez entrer une zone valide',
  'toast.enterValidValue': 'Entrez valeur valide (0-100)',
  'toast.fillAllCardInfo': 'Remplissez toutes les infos carte',
  'toast.invalidCardNumber': 'Numero carte invalide',
  'toast.invalidCvc': 'CVC invalide',
  'toast.invalidMonth': 'Mois invalide (1-12)',
  'toast.invalidYear': 'Annee invalide',
  'toast.paymentFailed': 'Paiement echoue. Reessayez.',
  'toast.paymentStatusCheckError': 'Impossible verifier statut paiement.',
  'toast.priceUpdated': 'Prix mis a jour',
  'toast.productAddedToCart': 'Produit ajoute au panier',
  'toast.productDetailsUpdated': 'Details produit mis a jour',
  'toast.selectAtLeastOneService': 'Selectionnez au moins un service',
  'toast.selectCustomer': 'Selectionnez un client',
  'toast.statsLoadError': 'Echec chargement statistiques',
  'toast.orderDetailsLoadError': 'Échec du chargement des détails de la commande',
  'toast.orderLoadError': 'Échec du chargement de la commande',
  'toast.customerExistingSelected': 'Client existant sélectionné',
  'toast.paymentFailedTryAgain': 'Paiement échoué. Veuillez réessayer.',
  'toast.paymentStatusCheckFailed': 'Impossible de vérifier le statut du paiement.',
  'toast.customerPhoneNotFound': 'Numéro de téléphone du client non trouvé',
  'toast.whatsappSent': 'Message WhatsApp envoyé ! ✅',
  'toast.whatsappFailed': 'Échec de l\'envoi du message WhatsApp',
  'toast.orderUpdateError': 'Échec de la mise à jour de la commande',
  'toast.searchError': 'Erreur de recherche',
  'toast.orderNotFound': 'Commande non trouvée',
  'toast.editCancelled': 'Édition annulée',
  'toast.noEditPermission': 'Vous n\'avez pas la permission de modifier les commandes passées',
  'toast.selectAtLeastOneOperation': 'Veuillez sélectionner au moins une opération',
  'toast.tailorAddedToCart': 'Opération de couture ajoutée au panier',
  'username': 'Nom Utilisateur',
  'warning': 'Avertissement',
  
  // Z-Report
  'zReport.singleDay': 'Jour unique',
  'zReport.dateRange': 'Plage de dates',
  'zReport.startDate': 'Date de début',
  'zReport.endDate': 'Date de fin',
  'zReport.totalOrders': 'Total commandes',
  'zReport.cancelledOrders': 'Commandes annulées',
  'zReport.totalRevenue': 'Revenu total',
  'zReport.paymentMethods': 'Méthodes de paiement',
  'zReport.cash': 'Espèces',
  'zReport.creditCard': 'Carte de crédit',
  'zReport.account': 'Compte',
  'zReport.free': 'Gratuit',
  'zReport.paidAtRegister': 'Payé à l\'enregistrement',
  'zReport.paidAtDelivery': 'Payé à la livraison',
  'zReport.collectionDetails': 'Détails de collecte',
  'zReport.incoming': 'Entrant',
  'zReport.outgoing': 'Sortant',
  'zReport.totalRegistered': 'Total enregistré',
  'zReport.expenses': 'Dépenses',
  'zReport.noExpenses': 'Pas de dépenses',
  'zReport.totalExpenses': 'Total dépenses',
  'zReport.cancelledReceipts': 'Reçus annulés',
  'zReport.reason': 'Raison',
  'zReport.noCancelled': 'Aucun reçu annulé',
  'zReport.totalCancelled': '{count} reçus annulés',
  'zReport.serviceBreakdown': 'Répartition par service',
  'zReport.loadError': 'Rapport Z non chargé',
  'zReport.excelError': 'Erreur export Excel',
  'zReport.excelDownloaded': 'Excel téléchargé',
  'zReport.loading': 'Chargement...',
  'zReport.todayOrders': "Commandes d'aujourd'hui",
  'zReport.registrationAndDelivery': 'Enregistrement + Livraison',
  'zReport.orderPaidAtRegister': 'Commande payée à l\'enregistrement',
  'zReport.orderPaidAtDelivery': 'Commande payée à la livraison',
  'zReport.accountCollections': 'Encaissements compte',
  'zReport.totalCollection': 'Total encaissement',
  'zReport.bankTransfer': 'Virement',
  'zReport.cashRegister': 'Caisse',
  'zReport.startingCash': 'Fonds de caisse initial',
  'zReport.dailyCashIncome': 'Entrée cash du jour',
  'zReport.cashToDeliver': 'Cash à livrer',
  'zReport.cashCalculation': '(Début + Cash du jour - Dépenses)',
  
  // Toast Messages
  'toast.productAddedSimple': 'Produit ajouté',
  'toast.deliveryDatePastError': 'La date de livraison ne peut pas être antérieure à aujourd\'hui',
  'toast.cardPaymentSuccessMsg': 'Paiement par carte réussi!',
  'toast.cardPaymentFailed': 'Paiement échoué. Veuillez réessayer.',
  'toast.paymentStatusCheckErrorShort': 'Impossible de vérifier le statut du paiement.',
  'toast.changeToPickupSuccess': 'Type de livraison changé en "Récupération personnelle"',
  'toast.changeToPickupError': 'Impossible de changer le type de livraison',
  'toast.changeToDeliverySuccess': 'Type de livraison changé en "Livraison à domicile"',
  'toast.changeToDelivery': 'Livraison à domicile',
  'toast.changeToPickup': 'Récupération personnelle',
  'deliveryPage.changeDeliveryType': 'Changer le type de livraison',
  'zReport.todayRegistrations': 'Enregistrements d\'aujourd\'hui',

  // Clés communes manquantes
  'common.allYears': 'Toutes les années',
  'common.autoDetected': 'Détecté automatiquement',
  'common.cancelled': 'Annulé',
  'common.items': 'Articles',
  'common.loadError': 'Impossible de charger',
  'common.none': 'Aucun',
  'common.ok': 'OK',
  'common.paid': 'Payé',
  'common.searchError': 'Erreur de recherche',
  'common.searchResults': '(Résultats de recherche)',
  'common.unit': 'Unité',
  'common.year': 'Année',

  // Relevé de compte
  'accountStatement.allTime': 'Toute la période',
  'accountStatement.customer': 'Client',
  'accountStatement.customerReceipts': 'Reçus client',
  'accountStatement.noData': 'Aucun relevé trouvé',
  'accountStatement.noReceipts': 'Aucun reçu trouvé',
  'accountStatement.payments': 'Paiements',
  'accountStatement.period': 'Période',
  'accountStatement.printStatement': 'Imprimer le relevé',
  'accountStatement.receipts': 'Reçus',
  'accountStatement.remaining': 'Solde restant',
  'accountStatement.statement': 'Relevé de compte',
  'accountStatement.totalPaid': 'Total payé',

  // Annonce
  'announcement.trialInfo': 'Période d\'essai en cours',
  'announcement.welcome': 'Bienvenue',

  // Attributs
  'attributes.color': 'Couleur',
  'attributes.deleteError': 'Impossible de supprimer l\'attribut',
  'attributes.deleted': 'Attribut supprimé',
  'attributes.name': 'Nom de l\'attribut',
  'attributes.noAttributes': 'Aucun attribut défini',
  'attributes.saveError': 'Impossible d\'enregistrer les attributs',
  'attributes.saved': 'Attributs enregistrés',
  'attributes.value': 'Valeur',

  // Relevé client
  'customerStatement.receiptDelivered': 'Livré',
  'customerStatement.receiptOpen': 'Ouvert',

  // Clients
  'customers.add': 'Ajouter un client',
  'customers.adres': 'Adresse',
  'customers.cannotDeleteWithOrders': 'Impossible de supprimer un client avec des commandes',
  'customers.legacyHidden': 'Masqué (Ancien)',
  'customers.notFound': 'Client non trouvé',
  'customers.phoneMissing': 'Numéro de téléphone manquant',
  'customers.telefon': 'Téléphone',
  'customers.telefon2': 'Téléphone 2',

  // Dommages
  'damage.add': 'Ajouter un dommage',
  'damage.description': 'Description',
  'damage.location': 'Emplacement',
  'damage.noPhoto': 'Pas de photo',
  'damage.photo': 'Photo',
  'damage.saveError': 'Impossible d\'enregistrer le rapport de dommage',
  'damage.saved': 'Rapport de dommage enregistré',
  'damage.severity': 'Gravité',
  'damage.title': 'Rapport de dommage',
  'damage.type': 'Type de dommage',

  // Tableau de bord
  'dashboard.allTime': 'Toute la période',
  'dashboard.referral.button': 'Copier le lien d\'invitation',
  'dashboard.referral.desc': '1 mois offert quand une entreprise invitée s’inscrit !',
  'dashboard.referral.title': 'Inviter des amis',

  // Livraison
  'delivery.complete': 'Livrer',
  'delivery.deliveredItems': 'Articles livrés',
  'delivery.deliveredProducts': 'Produits livrés',
  'delivery.error': 'Erreur de livraison',
  'delivery.noOrders': 'Aucune commande trouvée',
  'delivery.success': 'Livraison réussie',

  // Liste de livraison
  'deliveryList.address': 'Adresse',
  'deliveryList.cancelButton': 'Annuler',
  'deliveryList.cancelConfirm': 'Confirmer l\'annulation',
  'deliveryList.cancelReasonPlaceholder': 'Motif d\'annulation...',
  'deliveryList.cancelTitle': 'Annuler la commande',
  'deliveryList.complete': 'Terminer',
  'deliveryList.completed': 'Terminé',
  'deliveryList.delivered': 'Livré',
  'deliveryList.deliveryError': 'Erreur de livraison',
  'deliveryList.driver': 'Chauffeur',
  'deliveryList.items': 'Articles',
  'deliveryList.messageError': 'Erreur de message',
  'deliveryList.orderCancelled': 'Commande annulée',
  'deliveryList.orderDelivered': 'Commande livrée',
  'deliveryList.pending': 'En attente',
  'deliveryList.phone': 'Téléphone',
  'deliveryList.selectDriver': 'Sélectionner un chauffeur',
  'deliveryList.status': 'Statut',
  'deliveryList.title': 'Liste de livraison',
  'deliveryList.whatsappError': 'Erreur WhatsApp',
  'deliveryList.whatsappSent': 'Rappel WhatsApp envoyé ✅',
  'deliveryList.cancelError': 'Erreur d\'annulation',
  'deliveryList.branchUpdated': 'Agence de livraison mise à jour',
  'deliveryList.updateError': 'Mise à jour échouée',
  'deliveryList.noPhone': 'Téléphone client introuvable',
  'deliveryList.whatsappFailed': 'Envoi WhatsApp échoué',
  'deliveryList.whatsappTimeout': 'Délai WhatsApp dépassé',
  'deliveryList.waRemind': 'WA Rappel',
  'deliveryList.homeDelivery': 'Domicile',
  'deliveryList.selectBranch': 'Choisir agence',
  'deliveryList.noBranch': 'Aucune agence',
  'deliveryList.pickup': 'collecte',
  'deliveryList.noBranchAssigned': 'Aucune agence assignée',
  'deliveryList.changeBranch': 'Changer l\'agence de livraison',

  // Page de livraison
  'deliveryPage.changeToDelivery': 'Passer à la livraison',
  'deliveryPage.changeToDeliverySuccess': 'Changé en livraison',
  'deliveryPage.changeToPickup': 'Passer au retrait',
  'deliveryPage.changeToPickupError': 'Impossible de changer',
  'deliveryPage.changeToPickupSuccess': 'Changé en retrait',
  'deliveryPage.searchAll': 'Tous',
  'deliveryPage.searchBy': 'Rechercher par',
  'deliveryPage.searchName': 'Nom du client',
  'deliveryPage.searchNamePlaceholder': 'Entrer le n° reçu ou le nom client...',
  'deliveryPage.searchPhone': 'Rechercher par téléphone...',
  'deliveryPage.searchPhoneBtn': 'Rechercher par téléphone',
  'deliveryPage.searchPlaceholder': 'Rechercher...',
  'deliveryPage.searchReceipt': 'N° reçu',
  'deliveryPage.searchReceiptPlaceholder': 'Entrer le n° reçu...',
  'deliveryPage.searchEmptyTitle': 'Recherchez par n° reçu, nom ou téléphone',
  'deliveryPage.searchEmptySubtitle': 'Les commandes prêtes à livrer apparaîtront ici',

  // Chauffeur
  'driver.searchHint': 'Entrer au moins 2 caractères',
  'driver.searchPlaceholder': 'N° reçu, nom ou téléphone...',

  // Pied de page
  'footer.euServers': 'Serveurs UE',
  'footer.gdpr': 'Conforme RGPD',

  // Factures
  'invoices.downloading': 'Téléchargement en cours...',

  // Connexion
  'login.credentialsTitle': 'Identifiants',
  'login.enterCredentials': 'Entrer les identifiants',
  'login.forget': 'Mot de passe oublié ?',
  'login.saveCredentialsNote': 'Identifiants sauvegardés en sécurité',
  'login.tagline': 'Logiciel de nettoyage à sec — Solutions intelligentes pour votre entreprise.',
  'login.usernamePlaceholder': 'Entrer le nom d\'utilisateur...',

  // Menu
  'menu.driverPickup': 'Collecte chauffeur',
  'menu.hardware': 'Matériel',
  'menu.payment': 'Paiement',
  'menu.reportsCharts': 'Rapports & Graphiques',

  // Navigation
  'nav.logout': 'Déconnexion',
  'nav.user': 'Utilisateur',

  // Commande
  'order.amount': 'Montant',
  'order.homeDelivery': 'Livraison à domicile',
  'order.processing': 'Traitement en cours...',

  // Création de commande
  'orderCreate.pickupFromAddress': 'Récupérer à l\'adresse',
  'orderCreate.selectOperation': 'Sélectionner une opération',
  'orderCreate.selectedOperations': 'Opérations sélectionnées',

  // Paiement
  'payment.bank': 'Virement bancaire',
  'payment.collect': 'Encaisser',
  'payment.credit': 'Crédit',
  'payment.free': 'Gratuit',
  'payment.paymentCare': 'Paiement de compte',
  'payment.paymentsSaved': 'Paiements enregistrés',
  'payment.saveError': 'Impossible d\'enregistrer les paiements',
  'payment.saved': 'Paiement enregistré',
  'payment.split': 'Paiement fractionné',

  // Espaces réservés
  'placeholder.customerAddress': 'Entrer l\'adresse...',
  'placeholder.customerEmail': 'Entrer l\'e-mail...',
  'placeholder.customerName': 'Entrer le nom...',
  'placeholder.customerNotes': 'Entrer les notes...',
  'placeholder.customerPhone': 'Entrer le téléphone...',

  // Tarification
  'pricing.amount': 'Montant',
  'pricing.enterPrice': 'Entrer le prix',
  'pricing.percent': 'Pourcentage',

  // Produit
  'product.damage': 'Dommage',
  'product.stain': 'Tache',

  // Reçu
  'receipt.addressLabel': 'Adresse',
  'receipt.allYears': 'Toutes les années',
  'receipt.area': 'Surface',
  'receipt.backButton': 'Retour',
  'receipt.buyCredits': 'Acheter des crédits',
  'receipt.cancelled': 'Annulé',
  'receipt.cancelledBanner': 'Cette commande a été annulée',
  'receipt.cancelledBy': 'Annulé par',
  'receipt.cancelledDate': 'Date d\'annulation',
  'receipt.cancelledReason': 'Motif d\'annulation',
  'receipt.card': 'Carte',
  'receipt.cash': 'Espèces',
  'receipt.change': 'Monnaie',
  'receipt.connect': 'Connecter',
  'receipt.connected': 'Connecté',
  'receipt.copyButton': 'Copier',
  'receipt.copySend': 'Copier et envoyer',
  'receipt.copyTip': 'Copier le message',
  'receipt.creditsFinished': 'Crédits WhatsApp épuisés !',
  'receipt.customer': 'Client',
  'receipt.customerInfo': 'Info client',
  'receipt.customerName': 'Nom du client',
  'receipt.deliveryDate': 'Date de livraison',
  'receipt.discount': 'Remise',
  'receipt.discountedTotal': 'Montant réduit',
  'receipt.footerNote': 'Note de bas de page',
  'receipt.freeOfCharge': 'Gratuit',
  'receipt.generalTotal': 'Total général',
  'receipt.goToWhatsAppPage': 'Aller à la page WhatsApp ?',
  'receipt.grandTotal': 'Total final',
  'receipt.homeDelivery': 'Livraison à domicile',
  'receipt.invalid': 'Reçu invalide',
  'receipt.items': 'Articles',
  'receipt.label': 'Étiquette',
  'receipt.labelPrinted': 'Étiquette imprimée',
  'receipt.markAsDelivered': 'Marquer comme livré',
  'receipt.markAsReady': 'Marquer comme prêt',
  'receipt.markDeliveredError': 'Erreur lors du marquage comme livré',
  'receipt.markReadyError': 'Erreur lors du marquage comme prêt',
  'receipt.messageFailed': 'Message non envoyé',
  'receipt.messageSendFailed': 'L\'envoi du message a échoué',
  'receipt.messageSent': 'Message envoyé !',
  'receipt.new': 'Nouveau reçu',
  'receipt.noCollection': 'Aucune collection',
  'receipt.noReceiptFound': 'Aucun reçu trouvé',
  'receipt.notes': 'Notes',
  'receipt.onlyProEnterprise': 'Pro/Enterprise uniquement',
  'receipt.openWhatsApp': 'Ouvrir WhatsApp',
  'receipt.orderMarkedDelivered': 'Commande marquée comme livrée',
  'receipt.orderMarkedReady': 'Commande marquée comme prête',
  'receipt.orderNumber': 'Numéro de commande',
  'receipt.orderReceived': 'Commande reçue',
  'receipt.paid': 'Payé',
  'receipt.partialPayment': 'Paiement partiel',
  'receipt.paymentMethod': 'Mode de paiement',
  'receipt.phone': 'Téléphone',
  'receipt.phoneNotFound': 'Numéro de téléphone non trouvé',
  'receipt.piece': 'Pièce',
  'receipt.preview': 'Aperçu',
  'receipt.printError': 'Erreur d\'impression',
  'receipt.printerConnectError': 'Impossible de connecter l\'imprimante',
  'receipt.productsInfo': 'Produits',
  'receipt.receiptInfo': 'Informations du reçu',
  'receipt.remaining': 'Solde restant',
  'receipt.remainingCredits': 'Crédits restants',
  'receipt.reprint': 'Réimprimer',
  'receipt.scanQR': 'Scanner le QR code',
  'receipt.searchAll': 'Tous',
  'receipt.searchBy': 'Rechercher par',
  'receipt.searchError': 'Erreur de recherche',
  'receipt.searchName': 'Nom du client',
  'receipt.searchPhone': 'Téléphone',
  'receipt.searchReceipt': 'N° reçu',
  'receipt.searchReceiptPlaceholder': 'Entrer le n° reçu...',
  'receipt.searchTitle': 'Rechercher un reçu',
  'receipt.selectAll': 'Tout sélectionner',
  'receipt.serviceSummary': 'Résumé des services',
  'receipt.sessionNotFound': 'Session non trouvée. Veuillez vous reconnecter.',
  'receipt.status': 'Statut',
  'receipt.thermalPrinter': 'Imprimante thermique',
  'receipt.thisReceiptCancelled': 'Ce reçu a été annulé',
  'receipt.unknownError': 'Erreur inconnue',
  'receipt.whatsappFeature': 'Fonctionnalité WhatsApp',
  'receipt.whatsappNotConnected': 'WhatsApp non connecté !',
  'receipt.whatsappPreview': 'Aperçu WhatsApp',
  'receipt.whatsappPreviewDesc': 'Aperçu du message',
  'receipt.whatsappPreviewTitle': 'Aperçu',
  'receipt.year': 'Année',

  // Rapports
  'reports.averageOrder': 'Commande moyenne',
  'reports.ordersCount': 'Nombre de commandes',
  'reports.salesReport': 'Rapport de ventes',
  'reports.totalSales': 'Chiffre d\'affaires total',

  // Services
  'service.carpetShort': 'Tapis',
  'service.dryCleaningShort': 'Nettoyage',
  'service.ironingShort': 'Repassage',
  'service.dyeingShort': 'Teinture',
  'service.shoeShineShort': 'Chaussures',
  'service.tailoringShort': 'Couture',
  'service.washingShort': 'Lavage',

  // Paramètres
  'settings.africa': 'Afrique',
  'settings.americas': 'Amériques',
  'settings.asia': 'Asie',
  'settings.asiaPacific': 'Asie-Pacifique',
  'settings.asianLanguages': 'Langues asiatiques',
  'settings.autoConnect': 'Connexion automatique',
  'settings.browserNotSupported': 'Navigateur non pris en charge',
  'settings.callerId': 'ID d\'appelant',
  'settings.clickConnectButton': 'Cliquer sur Connecter',
  'settings.company': 'Entreprise',
  'settings.connectDeviceInfo': 'Informations sur l\'appareil',
  'settings.cut': 'Couper',
  'settings.email': 'E-mail',
  'settings.europe': 'Europe',
  'settings.europeanLanguages': 'Langues européennes',
  'settings.feedForward': 'Avance papier',
  'settings.formerSovietTurkic': 'Langues turques ex-soviétiques',
  'settings.genericEscPos': 'ESC/POS générique',
  'settings.howToConnect': 'Comment connecter',
  'settings.integrations': 'Intégrations',
  'settings.labelPrinter': 'Imprimante d\'étiquettes',
  'settings.lastCall': 'Dernier appel',
  'settings.majorCurrencies': 'Principales devises',
  'settings.middleEast': 'Moyen-Orient',
  'settings.middleEastAfricanLanguages': 'Langues Moyen-Orient & Afrique',
  'settings.middleEastGulf': 'Golfe du Moyen-Orient',
  'settings.notifications': 'Notifications',
  'settings.oceania': 'Océanie',
  'settings.openDrawer': 'Ouvrir le tiroir-caisse',
  'settings.otherLanguages': 'Autres langues',
  'settings.paperWidth': 'Largeur du papier',
  'settings.popularLanguages': 'Langues populaires',
  'settings.printer': 'Imprimante',
  'settings.printerConnect': 'Connecter l\'imprimante',
  'settings.printerConnected': 'Imprimante connectée',
  'settings.printerConnection': 'Connexion imprimante',
  'settings.printerDisconnect': 'Déconnecter l\'imprimante',
  'settings.printerModel': 'Modèle d\'imprimante',
  'settings.printerNotConnected': 'Imprimante non connectée',
  'settings.printerSettings': 'Paramètres d\'imprimante',
  'settings.receiptVisibleOnReceipt': 'Visible sur le reçu',
  'settings.reverse': 'Inverser',
  'settings.reverseTest': 'Test inversé',
  'settings.saveError': 'Impossible d\'enregistrer les paramètres',
  'settings.saved': 'Paramètres enregistrés',
  'settings.selectDevice': 'Sélectionner l\'appareil',
  'settings.successful': 'Réussi',
  'settings.testPrint': 'Impression test',
  'settings.testPrintHeader': 'En-tête d\'impression test',
  'settings.testPrinted': 'Impression test effectuée',
  'settings.turkey': 'Turquie',
  'settings.webSerialNotSupported': 'Web Serial non pris en charge',
  'settings.webSerialSupported': 'Web Serial pris en charge',

  // Inscription
  'signup.companyDetails': 'Détails de l\'entreprise',
  'signup.errors.companyCodeRequired': 'Code entreprise requis',
  'signup.errors.companyCodeTooShort': 'Code entreprise trop court',
  'signup.errors.companyNameRequired': 'Nom de l\'entreprise requis',
  'signup.errors.emailInvalid': 'Adresse e-mail invalide',
  'signup.errors.emailRequired': 'E-mail requis',
  'signup.errors.ownerNameRequired': 'Nom du propriétaire requis',
  'signup.errors.signupFailed': 'Inscription échouée',
  'signup.fields.companyCode': 'Code entreprise',
  'signup.fields.companyName': 'Nom de l\'entreprise',
  'signup.fields.country': 'Pays',
  'signup.fields.email': 'E-mail',
  'signup.fields.ownerName': 'Nom du propriétaire',
  'signup.fields.phone': 'Téléphone',
  'signup.haveAccount': 'Vous avez déjà un compte ?',
  'signup.placeholders.companyCode': 'Entrer le code entreprise...',
  'signup.placeholders.companyName': 'Entrer le nom de l\'entreprise...',
  'signup.placeholders.email': 'Entrer l\'e-mail...',
  'signup.placeholders.ownerName': 'Entrer le nom du propriétaire...',
  'signup.placeholders.phone': 'Entrer le téléphone...',
  'signup.referral.bonus': 'Bonus de parrainage',
  'signup.referral.title': 'Code d\'invitation',

  // Statut
  'status.cancelled': 'Annulé',
  'status.delivered': 'Livré',
  'status.pending': 'En attente',
  'status.pickup_in_progress': 'Collecte en cours',
  'status.pickup_pending': 'Collecte en attente',
  'status.ready': 'Prêt',
  'status.received': 'Reçu',

  // Abonnement
  'subscription.buyNow': 'Acheter maintenant',
  'subscription.cancel': 'Annuler l\'abonnement',
  'subscription.contactSales': 'Contacter les ventes',
  'subscription.contactSupport': 'Contacter le support',
  'subscription.currentPlan': 'Plan actuel',
  'subscription.currentUsage': 'Utilisation actuelle',
  'subscription.daysLeft': 'jours restants',
  'subscription.downgrade': 'Rétrograder',
  'subscription.endDate': 'Date de fin',
  'subscription.expired': 'Expiré',
  'subscription.expiredOn': 'Expiré le',
  'subscription.expiresOn': 'Expire le',
  'subscription.features': 'Fonctionnalités',
  'subscription.loading': 'Chargement de l\'abonnement...',
  'subscription.monthly': 'Mensuel',
  'subscription.monthlyLimit': 'Limite mensuelle',
  'subscription.noSubscription': 'Aucun abonnement actif',
  'subscription.payNow': 'Payer maintenant',
  'subscription.plan': 'Plan',
  'subscription.popular': 'Populaire',
  'subscription.pro': 'Pro',
  'subscription.renew': 'Renouveler',
  'subscription.renewNow': 'Renouveler maintenant',
  'subscription.startDate': 'Date de début',
  'subscription.trial': 'Essai',
  'subscription.trialDaysLeft': 'jours d\'essai restants',
  'subscription.trialEnd': 'Fin de l\'essai',
  'subscription.upgrade': 'Mettre à niveau',
  'subscription.yearly': 'Annuel',

  // Subscription page – missing UI strings (FR)
  'subscription.subtitle': 'Gérez votre plan et vos paramètres de facturation',
  'subscription.renewsInDays': 'Votre abonnement sera renouvelé dans {days} jours',
  'subscription.expiryLabel': "Date d'expiration:",
  'subscription.autoRenewActive': '✅ Renouvellement automatique actif - Prochain paiement:',
  'subscription.manageBilling': 'Gestion de la Facturation',
  'subscription.cancelSubBtn': "❌ Annuler l'Abonnement",
  'subscription.subCancelledBadge': '⚠️ Abonnement annulé',
  'subscription.paymentRequiredBadge': '💳 Paiement requis pour le renouvellement',
  'subscription.comparePlans': 'Comparer les Plans',
  'subscription.yearlyFreeBtn': '🎉 Annuel (2 Mois Offerts!)',
  'subscription.vatNote': '+ TVA (20%)',
  'subscription.autoRenewBadge': '🔄 Abonnement à renouvellement automatique',
  'subscription.emailNotifBadge': '💳 Notification par e-mail avant le renouvellement',
  'subscription.extendBtn': "Prolonger l'Abonnement",
  'subscription.selectBtn': 'Choisir',
  'subscription.upgradeBtn': 'Mettre à niveau',
  'subscription.usageTitle': 'Utilisation et Limites du Mois',
  'subscription.receiptsLabel': 'Reçus',
  'subscription.customersLabel': 'Clients',
  'subscription.usersLabel': 'Utilisateurs',
  'subscription.supportTimeLabel': 'Délai de Réponse Support',
  'subscription.referralTitle': 'Recommandez à vos Amis',
  'subscription.referralDesc': 'Quand un ami que vous invitez s’inscrit et devient membre, vous gagnez 1 mois supplémentaire ! Envoyer une invitation ne suffit pas.',
  'subscription.referralShare': "Partager le Lien d'Invitation",
  'subscription.faqTitle': 'Questions Fréquentes',
  'subscription.faq1q': "Que se passe-t-il lors d'un changement de plan?",
  'subscription.faq1a': "Lorsque vous changez de plan, vous accédez immédiatement aux nouvelles fonctionnalités. La durée de location que vous avez achetée s'ajoute à votre durée actuelle.",
  'subscription.faq2q': "Que se passe-t-il si j'annule?",
  'subscription.faq2a': "Si vous annulez votre abonnement, vous continuez à bénéficier du service jusqu'à la fin de la période en cours. Vos données sont conservées pendant 15 jours.",
  'subscription.faq3q': 'Quels moyens de paiement acceptez-vous?',
  'subscription.faq3a': "Seuls les paiements par carte de crédit et carte bancaire sont acceptés. Les virements bancaires ne sont pas acceptés.",
  'subscription.faq4q': "Comment fonctionne l'essai de 15 jours?",
  'subscription.faq4a': "Dès l'ouverture du compte, vous pouvez utiliser toutes les fonctionnalités gratuitement pendant 15 jours. À la fin de l'essai, vous devez souscrire un abonnement.",
  'subscription.trial15d': 'Essai de 15 jours',
  'subscription.billingDesc': "Entrez vos informations de facturation et passez à l'étape de paiement",
  'subscription.savedBillingInfo': '📄 Vos informations de facturation sauvegardées',
  'subscription.enterBillingInfo': '📄 Veuillez remplir vos informations de facturation',
  'subscription.billingAutoSave': '💾 Vos informations sont sauvegardées automatiquement pour votre prochain paiement',
  'subscription.billingLangLabel': 'Langue de Facturation',
  'subscription.taxOffice': 'Bureau des Impôts',
  'subscription.saveInfoBtn': '💾 Enregistrer les Informations',
  'subscription.saveInfoHint': 'Sera rempli automatiquement lors du prochain paiement',
  'subscription.billingInfoSaved': '✅ Informations de facturation sauvegardées',
  'subscription.cardInfoTitle': 'Informations de carte collectées sur la page de paiement',
  'subscription.subInfoTitle': "📋 Informations d'Abonnement",
  'subscription.subIsMonthly': "✅ Il s'agit d'un abonnement mensuel.",
  'subscription.subIsYearly': "✅ Il s'agit d'un abonnement annuel.",
  'subscription.autoRenewInfo': '🔄 Votre abonnement sera renouvelé automatiquement. Vous recevrez une notification par e-mail avant le renouvellement.',
  'subscription.cardAtPayment': '💳 Le paiement sera effectué avec vos informations de carte sur la page de paiement.',
  'subscription.cancelAnytime': "ℹ️ Vous pouvez annuler votre abonnement à tout moment.",
  'subscription.extendSubBtn': "💳 Prolonger l'Abonnement",
  'subscription.switchPlan': '💳 Changer de Plan',
  'subscription.changePlan': '💳 Modifier le Plan',
  'subscription.switchPlanIntl': '🏓 Changer de Plan',
  'subscription.changePlanIntl': '🏓 Modifier le Plan',
  'subscription.yearlyFreeNote': '🎉 2 mois offerts avec le paiement annuel!',
  'subscription.yearlySavings': '💡 Économisez 17% avec le paiement annuel',
  'subscription.planWord': 'Plan',
  'subscription.purchasePlanTitle': 'Acheter le Plan {name}',
  'subscription.totalAmountLabel': 'Montant Total',
  'subscription.extendedBy1m': 'Prolongé de 1 mois',
  'subscription.extendedBy1y': 'Prolongé de 1 an',

  // Settings receipt preview
  'settings.previewItem1': 'Article 1',
  'settings.previewItem2': 'Article 2',
  'settings.previewTotal': 'TOTAL',
  'settings.footerPlaceholder': 'Message de pied de page',
  'settings.receiptNote': 'Note du reçu',

  // Retouche
  'tailoring.addCustom': 'Ajouter personnalisé',
  'tailoring.astarDegisimi': 'Remplacement doublure',
  'tailoring.belAyarı': 'Ajustement taille',
  'tailoring.cancel': 'Annuler',
  'tailoring.cepDikimi': 'Couture poche',
  'tailoring.dugmeDikme': 'Coudre bouton',
  'tailoring.fermuarDegisimi': 'Remplacement fermeture',
  'tailoring.icon': 'Icône',
  'tailoring.kolBoyu': 'Longueur manche',
  'tailoring.omuzAyarı': 'Ajustement épaule',
  'tailoring.operationName': 'Nom de l\'opération',
  'tailoring.pacaBoyu': 'Longueur ourlet',
  'tailoring.price': 'Prix',
  'tailoring.save': 'Enregistrer',
  'tailoring.sokukDikimi': 'Couture ourlet',
  'tailoring.yama': 'Pièce',

  // Tickets de support
  'tickets.closed': 'Fermé',
  'tickets.translationError': 'Erreur de traduction',

  // Notifications toast
  'toast.logoTooLarge': 'Le fichier logo est trop volumineux',
  'toast.logoUploadError': 'Impossible de télécharger le logo',
  'toast.uploadingLogo': 'Téléchargement du logo...',

  // WhatsApp
  'whatsapp.buyCredits': 'Acheter des crédits',
  'whatsapp.connect': 'Connecter WhatsApp',
  'whatsapp.connected': 'Connecté',
  'whatsapp.creditPackages': 'Packs de crédits',
  'whatsapp.credits': 'Crédits',
  'whatsapp.creditsRemaining': 'crédits restants',
  'whatsapp.disconnect': 'Déconnecter',
  'whatsapp.messages': 'Messages',
  'whatsapp.noCredits': 'Aucun crédit disponible',
  'whatsapp.orderDelivered': 'Commande livrée',
  'whatsapp.orderReady': 'Commande prête',
  'whatsapp.preview': 'Aperçu',
  'whatsapp.receiptCreated': 'Reçu créé',
  'whatsapp.save': 'Enregistrer le modèle',
  'whatsapp.saved': 'Modèle enregistré',
  'whatsapp.scanQR': 'Scanner le QR code',
  'whatsapp.sendTest': 'Envoyer un message test',
  'whatsapp.status': 'Statut',
  'whatsapp.template': 'Modèle',
  'whatsapp.templates': 'Modèles',
  'whatsapp.testFailed': 'Message test échoué',
  'whatsapp.testSent': 'Message test envoyé',

  // Rapport Z
  'zReport.byEmployee': 'Par employé',
  'zReport.byProduct': 'Par produit',
  'zReport.byService': 'Par service',
  'zReport.cardPayments': 'Paiements par carte',
  'zReport.cashIn': 'Entrées',
  'zReport.cashOut': 'Sorties',
  'zReport.cashPayments': 'Paiements en espèces',
  'zReport.closingBalance': 'Solde de clôture',
  'zReport.creditPayments': 'Paiements à crédit',
  'zReport.custom': 'Personnalisé',
  'zReport.daily': 'Quotidien',
  'zReport.endDate': 'Date de fin',
  'zReport.free': 'Gratuit',
  'zReport.freeOrders': 'Commandes gratuites',
  'zReport.generateReport': 'Générer le rapport',
  'zReport.monthly': 'Mensuel',
  'zReport.newCustomers': 'Nouveaux clients',
  'zReport.openingBalance': 'Solde d\'ouverture',
  'zReport.printReport': 'Imprimer le rapport',
  'zReport.returningCustomers': 'Clients fidèles',
  'zReport.selectDate': 'Sélectionner la date',
  'zReport.serviceBreakdown': 'Détail par service',
  'zReport.startDate': 'Date de début',
  'zReport.title': 'Rapport Z',
  'zReport.totalCollected': 'Total encaissé',
  'zReport.totalItems': 'Total articles',
  'zReport.totalOrders': 'Total commandes',
  'zReport.totalRefunds': 'Total remboursements',
  'zReport.totalRevenue': 'Chiffre d\'affaires total',
  'zReport.transferPayments': 'Virements',
  'zReport.weekly': 'Hebdomadaire',
  'zreport.card': 'Carte',
  'zreport.cash': 'Espèces',
  'zreport.date': 'Date',
  'zreport.orders': 'Commandes',
  'zreport.print': 'Imprimer',
  'zreport.title': 'Rapport Z',
  'zreport.total': 'Total',

  // Receipt label dialog
  'receipt.labelConfirmTitle': 'Imprimer l\'étiquette?',
  'receipt.labelConfirmDesc': 'Reçu créé. Envoyer une étiquette à l\'imprimante?',
  'receipt.labelYes': 'Oui, Imprimer',
  'receipt.labelNo': 'Non',

  // ZReport notes
  'zReport.cashBoxStartNote': 'Solde initial de caisse',
  'zReport.todayCashNote': "Espèces reçues aujourd'hui",
  'zReport.branchCollectionsNote': 'Collections propre + autres agences',
  'zReport.dailyExpensesNote': 'Dépenses du jour',

  // CustomerCard
  'customerCard.balanceZero': 'Le solde est déjà à zéro.',
  'customerCard.debtLabel': 'la dette sera effacée',
  'customerCard.creditLabel': 'le crédit sera effacé',
  'customerCard.resetConfirm': 'Le solde sera remis à zéro ({label}). Confirmer?',
  'customerCard.resetSuccess': 'Solde remis à zéro',
  'customerCard.resetError': 'Impossible de remettre le solde à zéro',
  'customerCard.printTitle': 'Fiche Client',
  'customerCard.heading': 'FICHE CLIENT',
  'customerCard.tel1': 'TÉL 1',
  'customerCard.tel2': 'TÉL 2',
  'customerCard.address': 'ADRESSE',
  'customerCard.printButton': 'Imprimer la fiche client',
  'customerCard.resetting': 'Remise à zéro...',
  'customerCard.resetBalance': 'Remettre le solde à zéro',

  // Tailoring (missing)
  'tailoring.loadError': 'Impossible de charger les prix',
  'tailoring.nameRequired': "Veuillez saisir un nom d'opération",
  'tailoring.invalidPrice': 'Veuillez saisir un prix valide',
  'tailoring.addSuccess': 'Nouvelle opération de couture ajoutée!',
  'tailoring.saveError': 'Erreur de sauvegarde',
  'tailoring.deleteConfirm': 'Êtes-vous sûr de vouloir supprimer cette opération?',
  'tailoring.deleteSuccess': 'Opération supprimée',
  'tailoring.deleteError': 'Erreur de suppression',
  'tailoring.saveSuccess': 'Prix de couture sauvegardés!',
  'tailoring.addNewTitle': 'Nouvelle opération de couture',
  'tailoring.operationNameLabel': "Nom de l'opération",
  'tailoring.priceLabel': 'Prix',
  'tailoring.iconLabel': 'Icône (Emoji)',
  'tailoring.operationNamePlaceholder': 'Ex: Ourlet pantalon',
  'tailoring.savePricesHint': 'Cliquez sur Enregistrer pour sauvegarder les prix',
  'tailoring.addCustomHint': 'Utilisez le bouton + pour ajouter une opération personnalisée',

  // ReportsList (missing)
  'reportsList.title': 'Liste des reçus',
  'reportsList.startDate': 'Date de début',
  'reportsList.endDate': 'Date de fin',
  'reportsList.search': 'Rechercher',
  'reportsList.loading': 'Chargement...',
  'reportsList.description': 'Tous les reçus enregistrés ou livrés dans cette plage de dates sont listés',
  'reportsList.empty': 'Aucun reçu trouvé dans cette plage de dates',
  'reportsList.changeDateRange': 'Sélectionnez une autre plage de dates',
  'reportsList.categoryBreakdown': 'Répartition par catégorie',
  'reportsList.unknown': 'Inconnu',
  'reportsList.cancelReason': "Motif d'annulation:",
  'reportsList.excelDownloaded': 'Fichier Excel téléchargé',
  'reportsList.excelError': 'Impossible de créer le fichier Excel',
  'reportsList.totalReceipt': 'Total reçus',
  'reportsList.activeReceipt': 'Reçus actifs',
  'reportsList.loadError': 'Impossible de charger la liste des reçus',
  'reportsList.dateError': 'La date de début ne peut pas être postérieure à la date de fin',

  // Charts
  'charts.revenue': "Chiffre d'affaires",
  'charts.orders': 'Commandes',
  'charts.pieces': 'Nombre de pièces',
  'charts.receipts': 'Nombre de reçus',
  'charts.loadError': 'Impossible de charger les données',
  'charts.graphicReports': 'Rapports Graphiques',
  'charts.totalRevenue': "Chiffre d'affaires total",
  'charts.totalItems': 'Total pièces',
  'charts.totalReceipts': 'Total reçus',
  'charts.cashCard': 'Espèces + Carte bancaire',
  'charts.regDelivery': '(Enregistrement + Livraison)',
  'charts.collectionSummary': 'Résumé des encaissements',
  'charts.cashCardAtReg': '💵 Espèces/Carte (Enreg.):',
  'charts.cashCardAtDel': '💵 Espèces/Carte (Livr.):',
  'charts.currentCollections': '📋 Encaissements courants:',
  'charts.total': 'Total',
  'charts.noData': 'Aucune donnée pour cette période',
  'charts.selectPeriod': 'Sélectionnez une autre période',
  'charts.dailyRevenue': 'Graphique du CA quotidien',
  'charts.dailyItems': 'Graphique des pièces quotidien',
  'charts.top10Customers': 'Top 10 clients par CA',
  'charts.customer': 'Client',
  'charts.itemCount': 'Nombre de pièces',
  'charts.branchRevenue': 'CA par agence',
  'charts.periodSuffix': 'période',
  'reportsList.registeredThisPeriod': '📝 Enregistrés cette période ({count} reçus)',
  'reportsList.deliveredThisPeriod': '📦 Pré-enregistrés, livrés cette période ({count} reçus)',
  'reportsList.created': 'Création',
  'reportsList.delivered': 'Livraison',
  'customerStatement.selectDateRange': 'Sélectionner la période',
  'customerStatement.thisMonth': 'Ce mois',
  'customerStatement.lastMonth': 'Mois dernier',
  'customerStatement.allTime': 'Toutes périodes',
  'customerStatement.startDate': 'Date de début',
  'customerStatement.endDate': 'Date de fin',
  'customerStatement.printPDF': 'Imprimer le relevé (PDF)',
  'customerStatement.title': 'RELEVÉ DE COMPTE COURANT',
  'customerStatement.customerName': 'Nom du client',
  'customerStatement.phone': 'Téléphone',
  'customerStatement.address': 'Adresse',
  'customerStatement.openingBalance': 'Solde d\'ouverture',
  'customerStatement.closingBalance': 'Solde de clôture',
  'customerStatement.description': 'Description',
  'customerStatement.type': 'Type',
  'customerStatement.debit': 'Débit',
  'customerStatement.credit': 'Crédit (encaissé)',
  'customerStatement.total': 'TOTAL',
  'customerStatement.cancelled': 'ANNULÉ',
  'customerStatement.payment': 'Paiement',
  'customerStatement.items': 'article(s)',
  'customerStatement.noTransactions': 'Aucun mouvement sur la période sélectionnée.',
  'customerStatement.statementDate': 'Date du relevé',
  'tailoring.subtitle': 'Mettez à jour les prix des opérations de couture ici',
  'tailoring.addNewDescription': 'Ajoutez un type d\'opération de couture personnalisée',
  'tailoring.operationNamePlaceholder': 'Ex : Couture spéciale',
  'tailoring.add': 'Ajouter',
  'tailoring.savePrices': 'Enregistrer les prix',
  'tailoring.default': 'Par défaut',
  'tailoring.infoTitle': 'Informations',
  'tailoring.info1': 'Après avoir modifié les prix, cliquez sur "Enregistrer les prix"',
  'tailoring.info2': 'Utilisez "Nouvelle Opération" pour ajouter des types d\'opérations personnalisées',
  'tailoring.info3': 'Supprimez vos opérations personnalisées avec l\'icône corbeille',
  'tailoring.info4': 'Ces prix sont utilisés lors de la sélection du service couture dans une commande',
  'tailoring.info5': 'Vous pouvez définir un prix distinct pour chaque opération',
  'tailoring.info6': 'Les prix sont calculés automatiquement dans le panier client',

  'hardware.title': 'Boutique Matériel',
  'hardware.subtitle': 'Imprimantes de reçus, d\'étiquettes et appareils Caller ID',
  'hardware.cart': 'Panier',
  'hardware.infoTitle': 'Information',
  'hardware.infoText': 'Ces produits matériels ne sont actuellement disponibles à l\'achat qu\'en Turquie. Ils sont listés à titre informatif pour les autres pays.',
  'hardware.myCart': 'Mon Panier',
  'hardware.cartEmpty': 'Panier vide',
  'hardware.vatSuffix': '+ TVA',
  'hardware.total': 'Total',
  'hardware.checkout': 'Passer au paiement',
  'hardware.receiptPrinters': 'Imprimantes de reçus',
  'hardware.receiptPrintersSubtitle': 'Imprimantes thermiques 80mm avec coupe-papier automatique',
  'hardware.compatibilityTitle': 'Compatibilité CleandySoft',
  'hardware.receiptCompatText': 'Fonctionne avec toutes les imprimantes thermiques 80mm avec coupe-papier automatique.',
  'hardware.labelPrinters': 'Imprimantes d\'étiquettes',
  'hardware.labelPrintersSubtitle': 'Imprimantes matricielles, 76mm/57mm (Epson TM-U220, Bixolon SRP-270)',
  'hardware.testedModels': 'Modèles testés',
  'hardware.labelCompatText': 'Testé pour Epson TM-U220 et Bixolon SRP-270. D\'autres marques ou modèles peuvent rencontrer des problèmes.',
  'hardware.callerIdTitle': 'Appareils Caller ID',
  'hardware.callerIdSubtitle': 'Identification des appels clients',
  'hardware.compatibilityNote': 'Note de compatibilité',
  'hardware.callerIdCompatText': 'Testé uniquement pour le modèle CIDShow 2 lignes. D\'autres marques ou modèles peuvent fonctionner mais ne sont pas garantis.',
  'hardware.barcodeScanners': 'Scanners de codes-barres',
  'hardware.barcodeScannerSubtitle': 'Scanners USB codes-barres et QR codes',
  'hardware.barcodeCompatText': 'Tous les scanners 2D peuvent fonctionner avec CleandySoft. Les scanners en mode USB HID sont automatiquement pris en charge.',
  'hardware.driverDownloads': 'Téléchargements pilotes & logiciels',
  'hardware.driverDownloadsText': 'Il est recommandé de télécharger le pilote approprié avant de connecter l\'imprimante.',
  'hardware.onlyTurkey': 'Ce produit n\'est disponible à l\'achat qu\'en Turquie',
  'hardware.addedToCart': 'Ajouté au panier!',
  'hardware.available': 'Disponible',
  'hardware.info': 'Info',
  'hardware.features': 'Caractéristiques',
  'hardware.addToCart': 'Ajouter au panier',
  'hardware.infoOnly': 'À titre informatif',

  // Payment dialog
  'order.selectPaymentMethod': 'Choisir le mode de paiement',
  'payment.amountToPay': 'Montant à payer',
  'payment.remaining': 'Restant',
  'payment.splitPayment': 'Paiement fractionné',
  'payment.amount': 'Montant du paiement',
  'payment.enterAmount': 'Saisir le montant du paiement',
  'payment.madePayments': 'Paiements effectués',
  'toast.amountExceedsRemaining': 'Le montant dépasse le solde restant',
  'toast.selectPaymentMethodFirst': 'Choisissez d\'abord un mode de paiement',
};
